import React__default, { createElement, PureComponent, Component, useRef, useState, useLayoutEffect, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { isNil, get, noop, isFunction, omit, camelCase, keys, flow, map, split, size, find } from 'lodash';
import Popover, { ArrowContainer } from 'react-tiny-popover';
import { Constants, validateTimezone, getUtcIsoTimestamp } from '@nextiva/chat-core';
import { parseString } from 'xml2js';
import { utcToZonedTime, format } from 'date-fns-tz';
import { Handle, Range } from 'rc-slider';
import { getMinutes, getSeconds, format as format$1, formatDistanceToNow } from 'date-fns';
import { CirclePicker } from 'react-color';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var withFocusedState = function withFocusedState(WrappedComponent) {
  var WithFocusedState =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(WithFocusedState, _React$Component);

    function WithFocusedState() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, WithFocusedState);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WithFocusedState)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "state", {
        focused: false
      });

      _defineProperty(_assertThisInitialized(_this), "updateFocused", function (value) {
        return _this.setState({
          focused: value
        });
      });

      _defineProperty(_assertThisInitialized(_this), "onFocus", function (event) {
        var _this$props = _this.props,
            disabled = _this$props.disabled,
            onFocus = _this$props.onFocus,
            autoFocus = _this$props.autoFocus;
        if (disabled) return;

        if (autoFocus && !isNil(get(event, 'target.value'))) {
          var target = event.target;
          var value = target.value.toString();
          target.selectionStart = value.length;
          target.selectionEnd = value.length;
        }

        _this.updateFocused(true);

        if (onFocus) onFocus(event);
      });

      _defineProperty(_assertThisInitialized(_this), "onBlur", function (event) {
        var _this$props2 = _this.props,
            disabled = _this$props2.disabled,
            onBlur = _this$props2.onBlur;
        if (disabled) return;

        _this.updateFocused(false);

        if (onBlur) onBlur(event);
      });

      return _this;
    }

    _createClass(WithFocusedState, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.autoFocus) {
          this.updateFocused(true);
        }
      } // eslint-disable-next-line

    }, {
      key: "UNSAFE_componentWillReceiveProps",
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.disabled && this.state.focused) {
          this.updateFocused(false);
        }
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(WrappedComponent, _extends({}, this.props, {
          focused: this.state.focused,
          onFocus: this.onFocus,
          onBlur: this.onBlur
        }));
      }
    }]);

    return WithFocusedState;
  }(React__default.Component);

  _defineProperty(WithFocusedState, "propTypes", _objectSpread2({}, WrappedComponent.propTypes, {
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  }));

  _defineProperty(WithFocusedState, "defaultProps", _objectSpread2({}, WrappedComponent.defaultProps, {
    onFocus: noop,
    onBlur: noop
  }));

  return WithFocusedState;
};

var Button =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Button, _React$PureComponent);

  function Button() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Button)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "elem", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      hovered: false,
      pressed: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (event) {
      if (_this.props.disabled) return;

      _this.setState({
        hovered: true
      });

      _this.props.onMouseEnter(event);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function (event) {
      if (_this.props.disabled) return;

      _this.setState({
        hovered: false,
        pressed: false
      });

      _this.props.onMouseLeave(event);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function (event) {
      if (_this.props.disabled) return;

      _this.setState({
        pressed: true
      });

      if (!_this.props.focused) {
        // force focus for firefox on mouse click, because firefox ignores that one
        setTimeout(function () {
          return _this.elem && isFunction(_this.elem.focus) && _this.elem.focus();
        }, 4);
      }

      _this.props.onMouseDown(event);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseUp", function (event) {
      if (_this.props.disabled) return;

      _this.setState({
        pressed: false
      });

      _this.props.onMouseUp(event);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      if (_this.props.disabled) return;

      _this.props.onClick(event);
    });

    _defineProperty(_assertThisInitialized(_this), "ref", function (ref) {
      var innerRef = _this.props.innerRef;

      if (innerRef) {
        innerRef(ref);
      }

      _this.elem = ref;
    });

    return _this;
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _cx;

      var _this$props = this.props,
          type = _this$props.type,
          kind = _this$props.kind,
          disabled = _this$props.disabled,
          narrow = _this$props.narrow,
          Component = _this$props.component,
          blockName = _this$props.blockName,
          className = _this$props.className,
          focused = _this$props.focused,
          loading = _this$props.loading,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          children = _this$props.children,
          other = _objectWithoutProperties(_this$props, ["type", "kind", "disabled", "narrow", "component", "blockName", "className", "focused", "loading", "onFocus", "onBlur", "children"]);

      var _this$state = this.state,
          hovered = _this$state.hovered,
          pressed = _this$state.pressed;

      var props = _objectSpread2({}, omit(other, 'innerRef'), {
        type: ['button', 'input'].includes(String(Component)) ? type : undefined,
        disabled: disabled,
        className: cx(className, blockName, (_cx = {}, _defineProperty(_cx, "".concat(blockName, "--").concat(kind), kind), _defineProperty(_cx, "".concat(blockName, "--empty"), !children), _defineProperty(_cx, "".concat(blockName, "--disabled"), disabled === true), _defineProperty(_cx, "".concat(blockName, "--narrow"), narrow), _defineProperty(_cx, "".concat(blockName, "--active"), focused), _defineProperty(_cx, "".concat(blockName, "--hover"), hovered && !focused), _defineProperty(_cx, "".concat(blockName, "--hover-active"), hovered && focused), _defineProperty(_cx, "".concat(blockName, "--press"), pressed), _defineProperty(_cx, "".concat(blockName, "--loading"), loading), _cx)),
        ref: this.ref,
        onClick: this.handleClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp
      });

      return React__default.createElement(Component, props, children);
    }
  }]);

  return Button;
}(React__default.PureComponent);

_defineProperty(Button, "propTypes", {
  type: PropTypes.string,
  kind: PropTypes.string,
  disabled: PropTypes.bool,
  narrow: PropTypes.bool,

  /**
   * Sometimes we need other tags for rendering "button". (e.g. when we have nested clickable)
   * like http://stackoverflow.com/questions/26402033/missing-click-event-for-span-inside-button-element-on-firefox
   * React factory or string corresponding to a default JSX element
   * The component prop will be passed to React.createElement()
   */
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  blockName: PropTypes.string,

  /** Unlike blockName, it comes to `class` of `<button>` only once, without state modifiers. */
  className: PropTypes.string,
  focused: PropTypes.bool,
  loading: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  onClick: PropTypes.func,
  innerRef: PropTypes.func,
  children: PropTypes.node
});

_defineProperty(Button, "defaultProps", {
  type: 'button',
  kind: 'default',
  disabled: false,
  narrow: false,
  component: 'button',
  blockName: 'ch-button',
  focused: false,
  loading: false,
  onFocus: noop,
  onBlur: noop,
  onMouseEnter: noop,
  onMouseLeave: noop,
  onMouseDown: noop,
  onMouseUp: noop,
  onClick: noop
});

var Button$1 = withFocusedState(Button);

var ButtonComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ButtonComponent, _React$PureComponent);

  function ButtonComponent() {
    _classCallCheck(this, ButtonComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(ButtonComponent).apply(this, arguments));
  }

  _createClass(ButtonComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handler = _this$props.handler,
          value = _this$props.value,
          className = _this$props.className;
      return React__default.createElement("input", {
        onClick: handler,
        className: className,
        type: "button",
        value: value
      });
    }
  }]);

  return ButtonComponent;
}(React__default.PureComponent);

ButtonComponent.propTypes = {
  handler: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string
};
ButtonComponent.defaultProps = {
  handler: function handler() {},
  value: '',
  className: ''
};

var chatIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iODcuNyIgdmlld0JveD0iMCAwIDEwMCA4Ny43Ij48cGF0aCBkPSJNMTQuNiAxMUMyNC40IDMuNyAzNi4yIDAgNTAgMHMyNS42IDMuNiAzNS40IDEwLjlTMTAwIDI3LjEgMTAwIDM3LjZhMzAuNjIgMzAuNjIgMCAwMS01LjUgMTcuNyA0MC44NiA0MC44NiAwIDAxLTE1LjQgMTMuMnYuMnEwIDYuNDUgNS4xIDE1YTUgNSAwIDAxLjIgMS4yIDMgMyAwIDAxLS44IDIgMi41MiAyLjUyIDAgMDEtMi4xLjhoLS44YTM2Ljg3IDM2Ljg3IDAgMDEtMTMuMi01LjZjLTQuNi0zLTcuNy01LjQtOS4zLTcuM2EzMy4yMyAzMy4yMyAwIDAxLTUuNy40aC0yLjZjLTEzLjggMC0yNS42LTMuNi0zNS40LTEwLjlTMCA0OCAwIDM3LjYgNC45IDE4LjMgMTQuNiAxMXoiLz48L3N2Zz4=';

var normalizeMiddleware = function normalizeMiddleware(callback) {
  var normalizer = function normalizer(element) {
    var tagName = element['#name'];

    if (tagName === '__text__') {
      return {
        tagName: '',
        attributes: {},
        text: element._
      };
    }

    var attributes = _objectSpread2({}, element.$);

    var renameProps = {
      "class": 'className',
      "for": 'htmlFor'
    };
    keys(renameProps).forEach(function (key) {
      if (typeof attributes[key] !== 'undefined') {
        attributes[renameProps[key]] = attributes[key];
        delete attributes[key];
      }
    });
    return {
      attributes: attributes,
      tagName: element['#name'],
      children: (element.$$ || []).map(normalizer)
    };
  };

  return function (error, result) {
    callback(error, error ? result : normalizer(result));
  };
};

var parseXml = function parseXml(xml, callback) {
  return parseString(xml, {
    attrNameProcessors: [camelCase],
    charsAsChildren: true,
    explicitArray: true,
    explicitChildren: true,
    explicitRoot: false,
    mergeAttrs: false,
    normalizeTags: true,
    preserveChildrenOrder: true,
    trim: true
  }, normalizeMiddleware(callback));
};

var SVG_OPEN_TAG_PATTERN = /<svg+[^>]*>/;
var SVG_CLOSE_TAG_PATTERN = /<\/svg>/;
var BASE_64_TAG_PATTERN = /data:image\/svg\+xml;base64,/;
var blockName = 'Svg';

var Svg =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Svg, _React$PureComponent);

  function Svg() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Svg);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Svg)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "xhr", null);

    _defineProperty(_assertThisInitialized(_this), "mount", false);

    _defineProperty(_assertThisInitialized(_this), "state", {
      hovered: false,
      svgTag: {},
      svgContentRaw: null
    });

    _defineProperty(_assertThisInitialized(_this), "loadSvgRaw", function (src) {
      var onError = _this.props.onError;
      var base64Matches = src.match(BASE_64_TAG_PATTERN);

      if (base64Matches) {
        var decodedSrc = atob(src.replace(base64Matches[0], ''));

        _this.onLoadSvg(decodedSrc);
      } else {
        _this.xhr = new XMLHttpRequest();

        _this.xhr.open('GET', src);

        _this.xhr.onload = function () {
          if (_this.xhr.status >= 200 && _this.xhr.status < 300) {
            _this.onLoadSvg(_this.xhr.responseText);
          } else {
            onError("Could not donwnload Svg from ".concat(src));
          }
        };

        _this.xhr.send();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onLoadSvg", function (svgRaw) {
      var onLoad = _this.props.onLoad;

      _this.setSvg(svgRaw);

      if (onLoad) onLoad();
    });

    _defineProperty(_assertThisInitialized(_this), "setSvg", function (svgRaw) {
      _this.setSvgTag(svgRaw).then(function (svgTag) {
        var svgContentRaw = flow([_this.validateSvgFillColor, _this.cutSvgTag])(svgRaw);

        if (_this.mount) {
          _this.setState({
            svgTag: svgTag,
            svgContentRaw: svgContentRaw
          });
        }
      })["catch"](function (error) {
        throw new Error(error);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setSvgTag", function (svgRaw) {
      return new Promise(function (resolve, reject) {
        var svgMatches = svgRaw.match(SVG_OPEN_TAG_PATTERN);

        if (svgMatches) {
          var openTag = svgMatches[0];
          parseXml("".concat(openTag, "</svg>"), function (error, result) {
            if (error) {
              reject(error);
            } else {
              resolve(result);
            }
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "validateSvgFillColor", function (svgRaw) {
      var color = _this.props.color;
      return color ? svgRaw.replace(/fill=[""'].+?[""']/g, '') : svgRaw;
    });

    _defineProperty(_assertThisInitialized(_this), "cutSvgTag", function (svgRaw) {
      var pattern = new RegExp("".concat(SVG_OPEN_TAG_PATTERN.source, "|").concat(SVG_CLOSE_TAG_PATTERN.source), 'g');
      return svgRaw.replace(pattern, '');
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (event) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onMouseEnter = _this$props.onMouseEnter;

      if (!disabled) {
        _this.setState({
          hovered: true
        });

        onMouseEnter(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function (event) {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          onMouseLeave = _this$props2.onMouseLeave;

      if (!disabled) {
        _this.setState({
          hovered: false
        });

        onMouseLeave(event);
      }
    });

    return _this;
  }

  _createClass(Svg, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          svgRaw = _this$props3.svgRaw,
          src = _this$props3.src;
      this.mount = true;

      if (svgRaw) {
        this.setSvg(svgRaw);
      } else if (src) {
        this.loadSvgRaw(src);
      }
    } // eslint-disable-next-line

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props4 = this.props,
          src = _this$props4.src,
          svgRaw = _this$props4.svgRaw;

      if (svgRaw !== nextProps.svgRaw) {
        this.setSvg(nextProps.svgRaw);
      } else if (src !== nextProps.src) {
        this.loadSvgRaw(nextProps.src);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mount = false;

      if (this.xhr) {
        this.xhr.abort();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _cx;

      var _this$props5 = this.props,
          style = _this$props5.style,
          disabled = _this$props5.disabled,
          className = _this$props5.className,
          isActive = _this$props5.isActive,
          color = _this$props5.color,
          hoverColor = _this$props5.hoverColor,
          src = _this$props5.src,
          otherProps = _objectWithoutProperties(_this$props5, ["style", "disabled", "className", "isActive", "color", "hoverColor", "src"]);

      var _this$state = this.state,
          svgContentRaw = _this$state.svgContentRaw,
          hovered = _this$state.hovered,
          svgTag = _this$state.svgTag;
      return createElement("svg", _extends({}, svgTag.attributes, {
        className: cx(blockName, className, (_cx = {}, _defineProperty(_cx, "".concat(blockName, "--disabled"), disabled), _defineProperty(_cx, "".concat(blockName, "--active"), isActive), _defineProperty(_cx, "".concat(blockName, "--hovered"), hovered), _defineProperty(_cx, "".concat(className, "--disabled"), className && disabled), _defineProperty(_cx, "".concat(className, "--active"), className && isActive), _defineProperty(_cx, "".concat(className, "--hovered"), className && hovered), _cx)),
        style: _objectSpread2({
          fill: !disabled && (isActive || hovered) && hoverColor || color
        }, style)
      }, otherProps, {
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave // eslint-disable-next-line react/no-danger
        ,
        dangerouslySetInnerHTML: {
          __html: svgContentRaw
        }
      }));
    }
  }]);

  return Svg;
}(PureComponent);

_defineProperty(Svg, "propTypes", {
  className: PropTypes.string,
  src: PropTypes.string,
  onLoad: PropTypes.func,
  // raw loaded svg by 'raw-loader'
  svgRaw: function svgRaw(props, propName, componentName) {
    if (!props.src && !props.svgRaw) {
      return new Error("Warning: One of props 'src' or 'svgRaw' was not specified in '".concat(componentName, "'."));
    }

    if (props.svgRaw && typeof props.svgRaw !== 'string') {
      return new Error("Warning: Invalid prop 'svgRaw', expected 'string' in '".concat(componentName, "'."));
    }

    return undefined;
  },
  disabled: PropTypes.bool,
  isActive: PropTypes.bool,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.string),
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onError: PropTypes.func
});

_defineProperty(Svg, "defaultProps", {
  disabled: false,
  isActive: false,
  style: {},
  onMouseEnter: noop,
  onMouseLeave: noop,
  onError: noop
});

var ChatIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ChatIcon, _React$PureComponent);

  function ChatIcon() {
    _classCallCheck(this, ChatIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChatIcon).apply(this, arguments));
  }

  _createClass(ChatIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          className = _this$props.className;
      return React__default.createElement(Svg, {
        className: cx('abstract-icon', className),
        src: chatIcon,
        width: style.width,
        height: style.height,
        color: style.color
      });
    }
  }]);

  return ChatIcon;
}(React__default.PureComponent);

ChatIcon.propTypes = {
  style: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string
};
ChatIcon.defaultProps = {
  className: ''
};

var closeIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAuMDcgMTAwLjEiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik05Ny4yOCAxNC43M0w2MiA1MGwzNS4zIDM1LjNjMy44IDMuOCAzLjcgNy43LS4yIDExLjdzLTcuOSA0LjEtMTEuNy4zTDUwLjEgNjEuOSAxNC44IDk3LjJDMTEgMTAxIDcuMSAxMDAuOSAzLjEgOTdzLTQuMS03LjktLjMtMTEuN0wzOC4xOCA1MCAyLjg4IDE0LjczQy0uOTIgMTAuOTMtLjgyIDcgMy4wOCAzczcuOS00IDExLjctLjJsMzUuMyAzNS4zIDM1LjMtMzUuM2MzLjgtMy44IDcuNy0zLjcgMTEuNy4yczQgNy45My4yIDExLjczeiIvPjwvc3ZnPg==';

var CloseIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CloseIcon, _React$PureComponent);

  function CloseIcon() {
    _classCallCheck(this, CloseIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(CloseIcon).apply(this, arguments));
  }

  _createClass(CloseIcon, [{
    key: "render",
    value: function render() {
      return React__default.createElement(Svg, {
        className: "abstract-icon",
        src: closeIcon,
        width: 8
      });
    }
  }]);

  return CloseIcon;
}(React__default.PureComponent);

var collapseIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiA0LjI2Ij48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMzAgMGMxLjMxIDAgMiAuNjcgMiAycy0uNjQgMi0xLjkyIDJMMiA0LjI2Yy0xLjMxIDAtMi0uNjctMi0ycy42NC0yIDEuOTItMnoiLz48L3N2Zz4=';

var CollapseIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CollapseIcon, _React$PureComponent);

  function CollapseIcon() {
    _classCallCheck(this, CollapseIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(CollapseIcon).apply(this, arguments));
  }

  _createClass(CollapseIcon, [{
    key: "render",
    value: function render() {
      return React__default.createElement(Svg, {
        className: "abstract-icon",
        src: collapseIcon,
        width: 8
      });
    }
  }]);

  return CollapseIcon;
}(React__default.PureComponent);

var mailIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iNTcuOSIgdmlld0JveD0iMCAwIDEwMCA1Ny45Ij48cGF0aCBkPSJNNTMuMSA0NS4yYTQuNDMgNC40MyAwIDAxLTMgMS4xIDQuNzMgNC43MyAwIDAxLTIuOC0xLjFMMzAuNyAyOC4xdi0uM2ExLjc5IDEuNzkgMCAwMC0uNy0uNUwzLjcgMGg5NC4xem0tMTAuNyAyLjZhMTEuMjUgMTEuMjUgMCAwMDE1LjQuM2wxNS44LTE2TDk5IDU3LjdjLTIyLjYgMC03My40LjItOTYuNS4ybDI1LjQtMjV6TTEwMCA1LjF2NDcuNUw3Ni41IDI5ek0wIDQuNmwyNCAyNC45TDAgNTMuNHoiLz48L3N2Zz4=';

var MailIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(MailIcon, _React$PureComponent);

  function MailIcon() {
    _classCallCheck(this, MailIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(MailIcon).apply(this, arguments));
  }

  _createClass(MailIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          className = _this$props.className;
      var height = style.height,
          width = style.width,
          color = style.color;
      return React__default.createElement(Svg, {
        className: cx('abstract-icon', className),
        src: mailIcon,
        width: width,
        height: height,
        color: color
      });
    }
  }]);

  return MailIcon;
}(React__default.PureComponent);

MailIcon.propTypes = {
  style: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string
};
MailIcon.defaultProps = {
  className: ''
};

var nextivaLogo = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4NC45NiAyMy40OSI+PHBhdGggZmlsbD0iI2VkYWUyYiIgZD0iTTMzLjcyLS4wM2E0LjQgNC40IDAgMTEtNC40MiA0LjQgNC40MSA0LjQxIDAgMDE0LjQyLTQuNCIvPjxwYXRoIGZpbGw9IiNmZmZmZmUiIGQ9Ik04LjM2IDkuNzhIMHYxMy43aDMuOTRWMTIuNzJoMy40NGExLjQ3IDEuNDcgMCAwMTEuNDggMS40N3Y5LjNoMy45NHYtOS4zYTQuNDIgNC40MiAwIDAwLTQuNDQtNC40MW00My4zMyAxMC43NmgtMi41OGExLjQ3IDEuNDcgMCAwMS0xLjM2LTEuNDd2LTYuMzZoMy45NFY5Ljc3aC0zLjk0VjQuODhoLTMuOTR2NC44OWgtMS43M2wtMi4yMSAyLjk0aDMuOTR2Ni4zN2E0LjQxIDQuNDEgMCAwMDQuNDIgNC40aDMuNDR2LTIuOTQiLz48cGF0aCBmaWxsPSIjZmZmZmZlIiBkPSJNNDEuMTIgOS43OGgtNC40NGwtMi45NSAzLjkyLTIuOTYtMy45MmgtNC40M2w1LjE3IDYuODQtNS4xNyA2Ljg2aDQuNDNsMi45Ni0zLjkyIDIuOTUgMy45Mmg0LjQ0bC01LjE3LTYuODYgNS4xNy02Ljg0bTI3LjMgMGwtMy40NCA4LjcyLTMuNDQtOC43Mkg1Ny42bDUuNDIgMTMuN2gzLjkybDUuNDItMTMuN2gtMy45NG0tMTUuNzUgMTMuN2gzLjk0VjkuNzhoLTMuOTR2MTMuN3ptMC0xNC42OGgzLjk0VjQuODloLTMuOTRWOC44eiIvPjxwYXRoIGZpbGw9IiNmZmZmZmUiIGQ9Ik0yMC42NyAxMi43MmEzLjEgMy4xIDAgMDEyLjc0IDIuNDVoLTUuNDhhMy4wOSAzLjA5IDAgMDEyLjc0LTIuNDV6bTAgNy44MmEzLjEgMy4xIDAgMDEtMi43NC0yLjQ1aDkuNDhhNi45IDYuOSAwIDEwLTYuNzQgNS4zOWg0LjY3bDIuMjEtMi45NHptNTUuNDMtMi40Mkg4MXYyLjQ1aC00LjdhLjg3Ljg3IDAgMDEtLjIxIDAgMS4yMyAxLjIzIDAgMDEtMS0xLjE5IDEuMjEgMS4yMSAwIDAxMS4wMS0xLjI2em00LjQyLTguMzRoLTcuMThsLTEuMTYgMi45NGg3LjM1QTEuNDcgMS40NyAwIDAxODEgMTQuMTl2MWgtNS45YTQuMTUgNC4xNSAwIDAwMCA4LjNIODV2LTkuM2E0LjQzIDQuNDMgMCAwMC00LjQ4LTQuNDF6Ii8+PC9zdmc+';

var NextivaLogo = function NextivaLogo() {
  return React__default.createElement(Svg, {
    className: "nextiva-logo",
    src: nextivaLogo,
    width: 45
  });
};

var Avatar =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Avatar, _React$PureComponent);

  function Avatar() {
    _classCallCheck(this, Avatar);

    return _possibleConstructorReturn(this, _getPrototypeOf(Avatar).apply(this, arguments));
  }

  _createClass(Avatar, [{
    key: "render",
    value: function render() {
      var renderLogo = this.props.renderLogo;
      return React__default.createElement("span", {
        className: "rtc-chat-logo"
      }, renderLogo());
    }
  }]);

  return Avatar;
}(React__default.PureComponent);

Avatar.propTypes = {
  renderLogo: PropTypes.func
};

var addPx = function addPx(num) {
  return String("".concat(num, "px"));
};

var cleanupInput = function cleanupInput() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return value.trim().replace(/\n{2,}/gm, '\n\n');
};

var keyboardClick = function keyboardClick() {
  var onClick = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  return function (event) {
    var key = event.which.toString();

    if (key === '13' || key === '32') {
      event.preventDefault();
      onClick(event);
    }
  };
};

var shortenName = function shortenName(name) {
  if (!name) return 'Unknown Visitor';
  return name.split(' ').reduce(function (acc, part, index) {
    if (index === 0) return [part];
    return [].concat(_toConsumableArray(acc), ["".concat(part.substring(0, 1).toUpperCase(), ".")]);
  }, []).join(' ').trim();
};

var validateInput = function validateInput(_ref) {
  var value = _ref.value,
      name = _ref.name,
      regExp = _ref.regExp;

  if (regExp) {
    if (typeof regExp === 'string') {
      return new RegExp(regExp).test(value);
    }

    return regExp.test(value);
  } // eslint-disable-next-line max-len


  var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var isEmptyRegex = /^[\n\s]*$/;
  if (name === 'email') return emailRegex.test(value);
  return !isEmptyRegex.test(value);
};

var MinifyButton =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(MinifyButton, _React$PureComponent);

  function MinifyButton() {
    _classCallCheck(this, MinifyButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(MinifyButton).apply(this, arguments));
  }

  _createClass(MinifyButton, [{
    key: "render",
    value: function render() {
      var clickHandler = this.props.clickHandler;
      return React__default.createElement("span", {
        className: "hit-spot",
        onClick: clickHandler,
        onKeyDown: keyboardClick(clickHandler),
        role: "button",
        tabIndex: 0
      }, React__default.createElement("div", {
        className: "close-chat"
      }, React__default.createElement(CollapseIcon, null)));
    }
  }]);

  return MinifyButton;
}(React__default.PureComponent);

MinifyButton.propTypes = {
  clickHandler: PropTypes.func.isRequired
};

var CloseButton =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CloseButton, _React$PureComponent);

  function CloseButton() {
    _classCallCheck(this, CloseButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(CloseButton).apply(this, arguments));
  }

  _createClass(CloseButton, [{
    key: "render",
    value: function render() {
      var clickHandler = this.props.clickHandler;
      return React__default.createElement("span", {
        className: "hit-spot",
        onClick: clickHandler,
        onKeyDown: keyboardClick(clickHandler),
        role: "button",
        tabIndex: 0
      }, React__default.createElement("div", {
        className: "close-chat"
      }, React__default.createElement(CloseIcon, null)));
    }
  }]);

  return CloseButton;
}(React__default.PureComponent);

CloseButton.propTypes = {
  clickHandler: PropTypes.func.isRequired
};

var SvgButton = function SvgButton(_ref) {
  var _cx;

  var className = _ref.className,
      kind = _ref.kind,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      other = _objectWithoutProperties(_ref, ["className", "kind", "disabled", "onClick"]);

  var tabIndex = disabled ? -1 : 0;

  var handleClick = function handleClick(e) {
    if (!disabled) {
      onClick(e);
    }
  };

  return React__default.createElement(Svg, _extends({
    className: cx('ch-svg-button', (_cx = {}, _defineProperty(_cx, "ch-svg-button--".concat(kind), kind), _defineProperty(_cx, "ch-svg-button--disabled", disabled), _cx), className),
    tabIndex: tabIndex,
    role: "button",
    onClick: handleClick,
    onKeyDown: keyboardClick(handleClick)
  }, other));
};

SvgButton.propTypes = _objectSpread2({}, Svg.propTypes, {
  className: PropTypes.string,
  kind: PropTypes.oneOf(['gray', 'blue', 'widget']),
  disabled: PropTypes.bool
});
SvgButton.defaultProps = {
  className: '',
  kind: 'gray',
  disabled: false
};

var WelcomeButton =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(WelcomeButton, _React$PureComponent);

  function WelcomeButton() {
    _classCallCheck(this, WelcomeButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(WelcomeButton).apply(this, arguments));
  }

  _createClass(WelcomeButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          onlineText = _this$props.onlineText,
          offlineText = _this$props.offlineText,
          online = _this$props.online,
          clickHandler = _this$props.clickHandler;
      return React__default.createElement("button", {
        className: "chat-button",
        type: "button",
        style: online ? style.online.button : style.offline.button,
        onClick: clickHandler
      }, online ? React__default.createElement(ChatIcon, {
        className: "chat-button__icon",
        style: online ? style.online.icon : style.offline.icon
      }) : React__default.createElement(MailIcon, {
        className: "chat-button__icon",
        style: online ? style.online.icon : style.offline.icon
      }), React__default.createElement("span", {
        className: "chat-button__text-message"
      }, "".concat(online ? onlineText : offlineText)));
    }
  }]);

  return WelcomeButton;
}(React__default.PureComponent);

WelcomeButton.propTypes = {
  style: PropTypes.shape({
    online: PropTypes.shape({
      button: PropTypes.objectOf(PropTypes.string),
      icon: PropTypes.objectOf(PropTypes.string)
    }),
    offline: PropTypes.shape({
      button: PropTypes.objectOf(PropTypes.string),
      icon: PropTypes.objectOf(PropTypes.string)
    })
  }).isRequired,
  onlineText: PropTypes.string.isRequired,
  offlineText: PropTypes.string.isRequired,
  online: PropTypes.bool.isRequired,
  clickHandler: PropTypes.func.isRequired
};

var ButtonsContainer = function ButtonsContainer(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return React__default.createElement("div", {
    className: cx('ch-buttons-container', className)
  }, children);
};

ButtonsContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};
ButtonsContainer.defaultProps = {
  className: ''
};

var InputComponent = function InputComponent(_ref) {
  var value = _ref.value,
      handler = _ref.handler,
      name = _ref.name,
      className = _ref.className,
      placeholder = _ref.placeholder,
      pattern = _ref.pattern;
  return React__default.createElement("input", {
    type: "text",
    name: name,
    value: value,
    onChange: handler,
    pattern: pattern,
    placeholder: placeholder,
    className: className
  });
};

InputComponent.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  handler: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  pattern: PropTypes.string
};

var keyCodes = {
  BREAK: 3,
  BACKSPACE: 8,
  TAB: 9,
  CLEAR: 12,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  PAUSE: 19,
  CAPS_LOCK: 20,
  HANGUL: 21,
  HANJA: 25,
  ESCAPE: 27,
  CONVERSION: 28,
  NON_CONVERSION: 29,
  SPACEBAR: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40,
  SELECT: 41,
  PRINT: 42,
  EXECUTE: 43,
  PRINT_SCREEN: 44,
  INSERT: 45,
  DELETE: 46,
  HELP: 47,
  ZERO: 48,
  ONE: 49,
  TWO: 50,
  TREE: 51,
  FOUR: 52,
  FIVE: 53,
  SIX: 54,
  SEVEN: 55,
  EIGHT: 56,
  NINE: 57,
  SEMICOLON: 58,
  'EQUALS__SEMICOLON-FF': 59,
  '<': 60,
  'EQUALS-FF': 61,
  ß: 63,
  '@-FF': 64,
  a: 65,
  b: 66,
  c: 67,
  d: 68,
  e: 69,
  f: 70,
  g: 71,
  h: 72,
  i: 73,
  j: 74,
  k: 75,
  l: 76,
  m: 77,
  n: 78,
  o: 79,
  p: 80,
  q: 81,
  r: 82,
  s: 83,
  t: 84,
  u: 85,
  v: 86,
  w: 87,
  x: 88,
  y: 89,
  z: 90,
  'WINDOWS_KEY__LEFT-COMMAND__SEARCH': 91,
  RIGHT_WINDOWS_KEY: 92,
  WINDOWS_MENU__RIGHT_COMMAND: 93,
  sleep: 95,
  NUMPAD_0: 96,
  NUMPAD_1: 97,
  NUMPAD_2: 98,
  NUMPAD_3: 99,
  NUMPAD_4: 100,
  NUMPAD_5: 101,
  NUMPAD_6: 102,
  NUMPAD_7: 103,
  NUMPAD_8: 104,
  NUMPAD_9: 105,
  MULTIPLY: 106,
  ADD: 107,
  NUMPAD_PERIOD_FF: 108,
  SUBTRACT: 109,
  DECIMAL_POINT: 110,
  DIVIDE: 111,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  F13: 124,
  F14: 125,
  F15: 126,
  F16: 127,
  F17: 128,
  F18: 129,
  F19: 130,
  F20: 131,
  F21: 132,
  F22: 133,
  F23: 134,
  F24: 135,
  NUM_LOCK: 144,
  SCROLL_LOCK: 145,
  '^': 160,
  EXCLAMATION_POINT: 161,
  ARABIC_SEMICOLON: 162,
  '#': 163,
  $: 164,
  ù: 165,
  PAGE_BACKWARD: 166,
  PAGE_FORWARD: 167,
  REFRESH: 168,
  CLOSING_PAREN: 169,
  '*': 170,
  '~__*': 171,
  HOME_KEY: 172,
  'MINUS-FF__MUTE__UNMUTE': 173,
  DECREASE_VOLUME_LEVEL: 174,
  INCREASE_VOLUME_LEVEL: 175,
  NEXT: 176,
  PREVIOUS: 177,
  STOP: 178,
  PLAY__PAUSE: 179,
  EMAIL: 180,
  'MUTE--FF__UNMUTE--FF': 181,
  'DECREASE_VOLUME_LEVEL-FF': 182,
  'INCREASE_VOLUME_LEVEL-FF': 183,
  SEMICOLON__Ñ: 186,
  EQUAL_SIGN: 187,
  COMMA: 188,
  DASH: 189,
  PERIOD: 190,
  FORWARD_SLASH__ç: 191,
  'grave accent / ñ / æ / ö': 192,
  '?, / or °': 193,
  'NUMPAD_PERIOD-CH': 194,
  OPEN_BRACKET: 219,
  BACK_SLASH: 220,
  CLOSE_BRACKET__å: 221,
  SINGLE_QUOTE__ø__ä: 222,
  '`': 223,
  'COMMAND-FF': 224,
  ALTGR: 225,
  '< /git >__LEFT_BACK_SLASH': 226,
  'GNOME Compose Key': 230,
  ç: 231,
  XF86Forward: 233,
  XF86Back: 234,
  'non-conversion': 235,
  ALPHANUMERIC: 240,
  HIRAGANA_KATAKABA: 242,
  HALF_WIDTH__FULL_WIDTH: 243,
  KANJI: 244,
  'UNLOCK_TRACKPAD-CH-ED': 251,
  TOGGLE_TOUCHPAD: 255
};

var searchSvg = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNy43MyIgaGVpZ2h0PSIxNy44MDUiIHZpZXdCb3g9IjAgMCAxNy43MyAxNy44MDUiPjxkZWZzPjxjbGlwUGF0aCBpZD0iY2gtbG9va2luZy1nbGFzc19zdmdfX2EiPjxwYXRoIGQ9Ik0yNzQuNS0yMzEuNWwtNS4zLTUuM2E2LjYyNiA2LjYyNiAwIDAwMS41LTQuMyA2Ljk2NiA2Ljk2NiAwIDAwLTItNC45IDYuNDE2IDYuNDE2IDAgMDAtNC45LTIgNi45MDkgNi45MDkgMCAwMC00LjggMiA2LjQxNiA2LjQxNiAwIDAwLTIgNC45IDYuOTY2IDYuOTY2IDAgMDAyIDQuOSA2LjQxNiA2LjQxNiAwIDAwNC45IDIgNi42MjYgNi42MjYgMCAwMDQuMy0xLjVsNS4zIDUuM2EuNzI1LjcyNSAwIDAwMSAwIC43ODIuNzgyIDAgMDAwLTEuMXptLTEwLjYtNC4yYTQuOTE4IDQuOTE4IDAgMDEtMy44LTEuNiA1LjQ2NCA1LjQ2NCAwIDAxLTEuNi0zLjggNC45MTkgNC45MTkgMCAwMTEuNi0zLjggNS40NjUgNS40NjUgMCAwMTMuOC0xLjYgNS4wNjYgNS4wNjYgMCAwMTMuOCAxLjYgNS4wNjYgNS4wNjYgMCAwMTEuNiAzLjggNC45MTcgNC45MTcgMCAwMS0xLjYgMy44IDUuNDYzIDUuNDYzIDAgMDEtMy44IDEuNnoiIGZpbGw9IiM5Mzk1YWQiLz48L2NsaXBQYXRoPjxjbGlwUGF0aCBpZD0iY2gtbG9va2luZy1nbGFzc19zdmdfX2IiPjxwYXRoIGQ9Ik0tMzU1IDIzMDBoMjUzOFYtNzcxSC0zNTV6IiBmaWxsPSIjOTM5NWFkIi8+PC9jbGlwUGF0aD48L2RlZnM+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI1NyAyNDgpIiBjbGlwLXBhdGg9InVybCgjY2gtbG9va2luZy1nbGFzc19zdmdfX2EpIj48ZyBjbGlwLXBhdGg9InVybCgjY2gtbG9va2luZy1nbGFzc19zdmdfX2IpIj48cGF0aCBkPSJNMjUyLTI1M2gyNy43MzF2MjcuOEgyNTJ6IiBmaWxsPSIjOTM5NWFkIi8+PC9nPjwvZz48L3N2Zz4=';

var SearchField =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SearchField, _PureComponent);

  function SearchField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SearchField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SearchField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      focused: false,
      value: _this.props.value
    });

    _defineProperty(_assertThisInitialized(_this), "removeValue", function () {
      _this.props.onChange(null, '');
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      var _this$props = _this.props,
          value = _this$props.value,
          onKeyDown = _this$props.onKeyDown;
      onKeyDown(event);

      if (event.keyCode === keyCodes.ESCAPE) {
        event.preventDefault();
        event.stopPropagation();

        _this.removeValue();
      } else if (event.keyCode === keyCodes.ENTER) {
        _this.onSearch(value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function (event) {
      var onFocus = _this.props.onFocus;

      _this.setState({
        focused: true
      });

      onFocus(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function (event) {
      var onBlur = _this.props.onBlur;

      _this.setState({
        focused: false
      });

      onBlur(event);
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", function (value) {
      var onSearch = _this.props.onSearch;
      onSearch(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (event) {
      var onChange = _this.props.onChange;
      var value = event.target.value;
      onChange(event, value);
    });

    _defineProperty(_assertThisInitialized(_this), "renderIcon", function () {
      var _cx;

      var _this$props2 = _this.props,
          value = _this$props2.value,
          blockName = _this$props2.blockName;
      var focused = _this.state.focused;
      var className = cx("".concat(blockName, "__icon"), (_cx = {}, _defineProperty(_cx, "".concat(blockName, "__icon--active"), focused), _defineProperty(_cx, "".concat(blockName, "__icon--clear"), value), _cx));
      return value ? React__default.createElement(SvgButton, {
        className: className,
        onClick: _this.removeValue,
        src: closeIcon,
        height: 14
      }) : React__default.createElement(Svg, {
        className: className,
        src: searchSvg,
        height: 18
      });
    });

    return _this;
  }

  _createClass(SearchField, [{
    key: "render",
    value: function render() {
      var _cx2;

      var _this$props3 = this.props,
          placeholder = _this$props3.placeholder,
          blockName = _this$props3.blockName,
          containerClassName = _this$props3.containerClassName,
          inputClassName = _this$props3.inputClassName,
          isError = _this$props3.isError,
          disabled = _this$props3.disabled,
          autoFocus = _this$props3.autoFocus,
          value = _this$props3.value,
          _focused = _this$props3.focused,
          inputRef = _this$props3.inputRef,
          onSearch = _this$props3.onSearch,
          other = _objectWithoutProperties(_this$props3, ["placeholder", "blockName", "containerClassName", "inputClassName", "isError", "disabled", "autoFocus", "value", "focused", "inputRef", "onSearch"]);

      var focused = this.state.focused;
      var className = cx(blockName, containerClassName, (_cx2 = {}, _defineProperty(_cx2, "".concat(blockName, "--error"), isError), _defineProperty(_cx2, "".concat(blockName, "--active"), focused), _defineProperty(_cx2, "".concat(blockName, "--disabled"), disabled), _cx2));
      return React__default.createElement("div", {
        className: className
      }, React__default.createElement("input", _extends({}, other, {
        autoFocus: autoFocus // eslint-disable-line jsx-a11y/no-autofocus
        ,
        className: cx("".concat(blockName, "__input"), inputClassName),
        disabled: disabled,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.handleKeyDown,
        onChange: this.onChange,
        value: value,
        placeholder: placeholder,
        ref: inputRef
      })), this.renderIcon());
    }
  }]);

  return SearchField;
}(PureComponent);

_defineProperty(SearchField, "propTypes", {
  onChange: PropTypes.func,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  blockName: PropTypes.string,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  // it comes from the withFocusedState enhancer
  focused: PropTypes.bool,
  onSearch: PropTypes.func,
  onKeyDown: PropTypes.func,
  autoFocus: PropTypes.bool,
  isError: PropTypes.bool,
  disabled: PropTypes.bool,
  inputRef: PropTypes.func
});

_defineProperty(SearchField, "defaultProps", {
  value: '',
  placeholder: 'Search...',
  blockName: 'ch-searchfield',
  containerClassName: '',
  inputClassName: '',
  onChange: function onChange() {},
  onSearch: function onSearch() {},
  onKeyDown: function onKeyDown() {},
  autoFocus: false,
  isError: false,
  disabled: false,
  focused: false
});

var SearchField$1 = withFocusedState(SearchField);

var TEXT_FIELD_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  TEXTAREA: 'textarea',
  CURRENCY: 'currency',
  PERCENT: 'percent',
  EMAIL: 'email',
  URL: 'url'
};
var inputRefPropType = PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
  current: PropTypes.instanceOf( // eslint-disable-next-line func-names
  typeof Element === 'undefined' ? function () {} : Element)
})]);
var blockName$1 = 'ch-textfield';

var TextField =
/*#__PURE__*/
function (_Component) {
  _inherits(TextField, _Component);

  function TextField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TextField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TextField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      _this.props.onChange(event, event.target.value);
    });

    return _this;
  }

  _createClass(TextField, [{
    key: "renderInput",
    value: function renderInput(inputProps) {
      var type = inputProps.type,
          inputClassName = inputProps.inputClassName,
          inputId = inputProps.inputId,
          inputRef = inputProps.inputRef,
          other = _objectWithoutProperties(inputProps, ["type", "inputClassName", "inputId", "inputRef"]);

      var componentType = type === TEXT_FIELD_TYPES.TEXTAREA ? type : 'input';
      var finalInputClassName = cx(inputClassName, "".concat(blockName$1, "__input"), _defineProperty({}, "".concat(blockName$1, "__input--type-").concat(componentType), componentType));
      return createElement(componentType, _objectSpread2({}, other, {
        type: type === TEXT_FIELD_TYPES.TEXTAREA ? undefined : type,
        id: inputId,
        ref: inputRef,
        onChange: this.handleChange,
        className: finalInputClassName,
        onKeyDown: this.handleKeyDown,
        onPaste: this.handlePaste
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _cx2;

      var _this$props = this.props,
          isError = _this$props.isError,
          focused = _this$props.focused,
          className = _this$props.className,
          readOnly = _this$props.readOnly,
          type = _this$props.type,
          errorMessage = _this$props.errorMessage,
          kind = _this$props.kind,
          other = _objectWithoutProperties(_this$props, ["isError", "focused", "className", "readOnly", "type", "errorMessage", "kind"]);

      var finalClassName = cx(className, blockName$1, (_cx2 = {}, _defineProperty(_cx2, "".concat(blockName$1, "--error"), isError), _defineProperty(_cx2, "".concat(blockName$1, "--active"), focused), _defineProperty(_cx2, "".concat(blockName$1, "--active-error"), isError && focused), _defineProperty(_cx2, "".concat(blockName$1, "--type-").concat(type), type), _defineProperty(_cx2, "".concat(blockName$1, "--kind-").concat(kind), kind), _cx2));

      var inputProps = _objectSpread2({}, other, {
        type: type,
        readOnly: readOnly
      });

      var showErrorMessage = isError && errorMessage;
      return React__default.createElement("div", {
        className: finalClassName
      }, this.renderInput(inputProps), showErrorMessage && React__default.createElement("p", {
        className: "".concat(blockName$1, "__error-message")
      }, errorMessage));
    }
  }]);

  return TextField;
}(Component);

_defineProperty(TextField, "propTypes", {
  /** `type` property of `<input>` tag. */
  type: PropTypes.string,
  onCut: PropTypes.func,
  value: PropTypes.string,
  onBlur: PropTypes.func,
  onCopy: PropTypes.func,
  onPaste: PropTypes.func,

  /** `id` of native `<input>`. */
  inputId: PropTypes.string,
  inputRef: inputRefPropType,
  onFocus: PropTypes.func,
  isError: PropTypes.bool,
  focused: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  placeholder: PropTypes.string,
  errorMessage: PropTypes.string,
  kind: PropTypes.oneOf(['default', 'gray'])
});

_defineProperty(TextField, "defaultProps", {
  type: 'text',
  value: '',
  onCut: noop,
  onBlur: noop,
  onCopy: noop,
  onPaste: noop,
  inputRef: noop,
  isError: false,
  focused: false,
  onFocus: noop,
  onChange: noop,
  autoFocus: false,
  readOnly: false,
  errorMessage: '',
  kind: 'default'
});

var TextField$1 = withFocusedState(TextField);

var TextArea =
/*#__PURE__*/
function (_Component) {
  _inherits(TextArea, _Component);

  function TextArea() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TextArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TextArea)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      if (!_this.props.autosize || !_this.inputRef) return;
      _this.inputRef.style.height = 'auto';
      _this.inputRef.style.height = "".concat(_this.inputRef.scrollHeight, "px");
      _this.inputRef.scrollTop = _this.inputRef.scrollHeight;
    });

    return _this;
  }

  _createClass(TextArea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Call immediately to prevent component gets shrunk in height on page refresh
      this.handleResize(); // Wait until the custom fonts are applied.

      setTimeout(this.handleResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.handleResize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          inputClassName = _this$props.inputClassName,
          classes = _this$props.classes,
          autosize = _this$props.autosize,
          other = _objectWithoutProperties(_this$props, ["className", "inputClassName", "classes", "autosize"]);

      return React__default.createElement(TextField$1, _extends({}, other, {
        type: "textarea",
        className: className,
        inputClassName: inputClassName,
        inputRef: function inputRef(input) {
          _this2.inputRef = input;
        }
      }));
    }
  }]);

  return TextArea;
}(Component);

_defineProperty(TextArea, "displayName", 'TextArea');

_defineProperty(TextArea, "propTypes", _objectSpread2({}, TextField$1.propTypes, {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  rows: PropTypes.number,
  autosize: PropTypes.bool
}));

_defineProperty(TextArea, "defaultProps", {
  /** Native <textarea> prop, works as calculated height (or min-height, if autosize is enabled). */
  rows: 2,
  autosize: true
});

var TextArea$1 = withFocusedState(TextArea);

var TextAreaComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(TextAreaComponent, _React$PureComponent);

  function TextAreaComponent() {
    _classCallCheck(this, TextAreaComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(TextAreaComponent).apply(this, arguments));
  }

  _createClass(TextAreaComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          handler = _this$props.handler,
          name = _this$props.name,
          className = _this$props.className,
          placeholder = _this$props.placeholder;
      return React__default.createElement("textarea", {
        type: "textarea",
        name: name,
        value: value,
        onChange: handler,
        placeholder: placeholder,
        className: className
      });
    }
  }]);

  return TextAreaComponent;
}(React__default.PureComponent);

TextAreaComponent.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  handler: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string
};

var DotLoader = function DotLoader(_ref) {
  var className = _ref.className,
      done = _ref.done;
  return React__default.createElement("div", {
    className: cx('ch-dot-loader', {
      'ch-dot-loader--done': done
    }, className)
  }, React__default.createElement("div", {
    className: cx('ch-dot-loader__dot', 'ch-dot-loader__dot--1')
  }), React__default.createElement("div", {
    className: cx('ch-dot-loader__dot', 'ch-dot-loader__dot--2')
  }), React__default.createElement("div", {
    className: cx('ch-dot-loader__dot', 'ch-dot-loader__dot--3')
  }));
};

DotLoader.propTypes = {
  className: PropTypes.string,
  done: PropTypes.bool
};
DotLoader.defaultProps = {
  className: '',
  done: false
};

var AgentChatTransferHeader = function AgentChatTransferHeader(_ref) {
  var _cx;

  var className = _ref.className,
      isGroupChat = _ref.isGroupChat,
      inProgress = _ref.inProgress,
      isError = _ref.isError,
      isHidden = _ref.isHidden;
  var blockName = 'ch-chat-transfer-header';
  var transferText = inProgress ? 'Transferring Chat' : 'Transfer Chat To';
  var groupText = "".concat(inProgress ? 'Creating' : 'Create', " Group Chat");
  var finalText = isGroupChat ? groupText : transferText;
  var errorText = "".concat(isGroupChat ? 'Group Chat' : 'Transfer Request', " Failed");
  var finalClassName = cx(blockName, (_cx = {}, _defineProperty(_cx, "".concat(blockName, "--in-progress"), inProgress && !isError), _defineProperty(_cx, "".concat(blockName, "--error"), isError), _defineProperty(_cx, "".concat(blockName, "--hidden"), isHidden), _cx), className);
  return React__default.createElement("div", {
    className: finalClassName
  }, React__default.createElement("div", {
    className: "".concat(blockName, "__text")
  }, isError ? errorText : finalText), React__default.createElement(DotLoader, {
    className: "".concat(blockName, "__loader")
  }));
};

AgentChatTransferHeader.propTypes = {
  className: PropTypes.string,
  isGroupChat: PropTypes.bool.isRequired,
  inProgress: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
  isHidden: PropTypes.bool.isRequired
};
AgentChatTransferHeader.defaultProps = {
  className: ''
};

var UserStatusIcon = function UserStatusIcon(_ref) {
  var _cx;

  var className = _ref.className,
      status = _ref.status,
      withBorder = _ref.withBorder,
      size = _ref.size;
  return React__default.createElement("div", {
    className: cx('status-round', (_cx = {}, _defineProperty(_cx, "status-round--".concat(status), status), _defineProperty(_cx, "status-round--with-border", withBorder), _defineProperty(_cx, "status-round--".concat(size), size), _cx), className)
  });
};

UserStatusIcon.propTypes = {
  className: PropTypes.string,
  status: PropTypes.string,
  withBorder: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large'])
};
UserStatusIcon.defaultProps = {
  className: '',
  status: 'offline',
  withBorder: false
};

var addAgentIcon = 'data:image/svg+xml;base64,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';

var transferIcon = 'data:image/svg+xml;base64,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';

var AgentChatTransferUser = function AgentChatTransferUser(_ref) {
  var _cx;

  var className = _ref.className,
      agent = _ref.agent,
      onAddAgent = _ref.onAddAgent,
      onTransfer = _ref.onTransfer,
      style = _ref.style,
      disabled = _ref.disabled,
      transferOnly = _ref.transferOnly,
      oldTop = _ref.oldTop;
  var ref = useRef(null);
  var timeoutRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isAnimated = _useState2[0],
      setIsAnimated = _useState2[1];

  var blockName = 'ch-transfer-user';
  var finallClassName = cx(blockName, (_cx = {}, _defineProperty(_cx, "".concat(blockName, "--no-controls"), transferOnly), _defineProperty(_cx, "".concat(blockName, "--disabled"), disabled), _defineProperty(_cx, "".concat(blockName, "--animated"), isAnimated), _cx), className);

  var _useState3 = useState(style),
      _useState4 = _slicedToArray(_useState3, 2),
      finalStyle = _useState4[0],
      setFinalStyle = _useState4[1];

  var getTopPosition = function getTopPosition() {
    return ref.current.getBoundingClientRect().top;
  };

  useLayoutEffect(function () {
    if (oldTop) {
      var newTop = getTopPosition();
      var deltaY = oldTop - newTop;
      setFinalStyle(_objectSpread2({}, style, {
        transform: "translateY(".concat(deltaY, "px)")
      }));
      timeoutRef.current = setTimeout(function () {
        setFinalStyle(_objectSpread2({}, style, {
          transform: 'none'
        }));
        setIsAnimated(true);
      }, 100);
    }

    return function () {
      if (timeoutRef.current !== null) clearTimeout(timeoutRef.current);
    };
  }, [oldTop, style]);

  var handleTransfer = function handleTransfer() {
    onTransfer(agent, getTopPosition());
  };

  var handleAddAgent = function handleAddAgent() {
    onAddAgent(agent, getTopPosition());
  };

  var renderDetails = function renderDetails() {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
      className: "".concat(blockName, "__status")
    }, React__default.createElement(UserStatusIcon, {
      className: "".concat(blockName, "__status-icon"),
      status: agent.status,
      size: "small"
    })), React__default.createElement("div", {
      className: "".concat(blockName, "__details")
    }, React__default.createElement("div", {
      className: "".concat(blockName, "__name")
    }, agent.name), React__default.createElement("div", {
      className: "".concat(blockName, "__department")
    }, agent.department)));
  };

  if (disabled) {
    return React__default.createElement("div", {
      className: finallClassName,
      ref: ref,
      style: finalStyle
    }, renderDetails());
  }

  if (transferOnly) {
    return React__default.createElement("div", {
      className: finallClassName,
      ref: ref,
      onClick: handleTransfer,
      style: finalStyle,
      tabIndex: 0,
      role: "button",
      onKeyDown: keyboardClick(handleTransfer)
    }, renderDetails());
  }

  return React__default.createElement("div", {
    ref: ref,
    className: finallClassName,
    style: finalStyle
  }, renderDetails(), React__default.createElement("div", {
    className: "".concat(blockName, "__controls")
  }, React__default.createElement(SvgButton, {
    className: "".concat(blockName, "__add-agent"),
    src: addAgentIcon,
    height: 14,
    onClick: handleAddAgent,
    kind: "gray"
  }), React__default.createElement(SvgButton, {
    className: "".concat(blockName, "__transfer"),
    src: transferIcon,
    height: 14,
    onClick: handleTransfer,
    kind: "gray"
  })));
};

AgentChatTransferUser.propTypes = {
  className: PropTypes.string,
  agent: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number])),
  onTransfer: PropTypes.func,
  onAddAgent: PropTypes.func,
  userRef: PropTypes.func,
  style: PropTypes.objectOf(PropTypes.string),
  disabled: PropTypes.bool,
  transferOnly: PropTypes.bool,
  oldTop: PropTypes.number
};
AgentChatTransferUser.defaultProps = {
  className: '',
  style: {},
  disabled: false,
  onTransfer: noop,
  onAddAgent: noop
};

var ScrollContainer = function ScrollContainer(_ref) {
  var _cx;

  var className = _ref.className,
      children = _ref.children,
      shouldScrollToBottom = _ref.shouldScrollToBottom,
      onScroll = _ref.onScroll,
      maxHeight = _ref.maxHeight;
  var blockName = 'ch-scroll-container';
  var scrollDebounceTime = 300;
  var containerRef = useRef(null);
  var containerEndRef = useRef(null);
  var scrollDebounceRef = useRef(null);
  var autoScrollDebounceRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showTopShadow = _useState2[0],
      setShowTopShadow = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showBottomShadow = _useState4[0],
      setShowBottomShadow = _useState4[1];

  var scrollToBottom = function scrollToBottom() {
    if (containerEndRef.current === null) return;
    containerEndRef.current.scrollIntoView({
      behavior: 'smooth'
    });
  };

  var checkScrollPosition = function checkScrollPosition() {
    if (containerRef.current === null) return;
    var _containerRef$current = containerRef.current,
        scrollTop = _containerRef$current.scrollTop,
        scrollHeight = _containerRef$current.scrollHeight,
        offsetHeight = _containerRef$current.offsetHeight;
    var top = Math.ceil(scrollTop);
    var canBeScrolled = scrollHeight > offsetHeight;
    var updatedShowTopShadow = canBeScrolled && top > 5;
    var updatedShowBottomShadow = canBeScrolled && top + offsetHeight < scrollHeight - 5;
    setShowTopShadow(updatedShowTopShadow);
    setShowBottomShadow(updatedShowBottomShadow);
  };

  var handleScroll = function handleScroll(event) {
    checkScrollPosition();

    if (onScroll) {
      scrollDebounceRef.current = setTimeout(function () {
        onScroll(event);
      }, scrollDebounceTime);
    }
  };

  useEffect(function () {
    var scrollDebounce = scrollDebounceRef.current;

    if (shouldScrollToBottom) {
      autoScrollDebounceRef.current = setTimeout(function () {
        scrollToBottom();
      }, scrollDebounceTime / 2);
    }

    checkScrollPosition();
    var autoScrollDebounce = autoScrollDebounceRef.current;
    return function () {
      if (scrollDebounce !== null) clearTimeout(scrollDebounce);
      if (autoScrollDebounce !== null) clearTimeout(autoScrollDebounce);
    };
  }, [children, shouldScrollToBottom]);
  var containerClassName = cx(blockName, (_cx = {}, _defineProperty(_cx, "".concat(blockName, "--with-top-shadow"), showTopShadow), _defineProperty(_cx, "".concat(blockName, "--with-bottom-shadow"), showBottomShadow), _cx), className);
  return React__default.createElement("div", {
    className: containerClassName,
    ref: containerRef,
    onScroll: handleScroll,
    style: {
      maxHeight: maxHeight
    }
  }, children, React__default.createElement("div", {
    ref: containerEndRef,
    style: {
      "float": 'left',
      clear: 'both'
    }
  }));
};

ScrollContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  onScroll: PropTypes.func,
  shouldScrollToBottom: PropTypes.bool,
  maxHeight: PropTypes.number
};
ScrollContainer.defaultProps = {
  className: '',
  shouldScrollToBottom: false
};

var backIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMi4wMTgiIHZpZXdCb3g9IjAgMCAxMiAxMi4wMTgiPjxwYXRoIGQ9Ik0xMS4xOTUgNS4xODJIMi42MTJsMy4zNDItMy42MzhBLjk1Ni45NTYgMCAwMDUuOTcuMjcxLjc3OS43NzkgMCAwMDQuOC4yNTRsLTQuNTkyIDVhMS41MzkgMS41MzkgMCAwMDAgMS41NjJsNC41OTIgNC45OWEuNzY0Ljc2NCAwIDAwMS4xLS4wNDUuOTQuOTQgMCAwMC4wNDItMS4yTDIuNiA2LjkyM2g4LjZhLjg4Ni44ODYgMCAwMDAtMS43NjV6IiBmaWxsPSIjODI5YWI1Ii8+PC9zdmc+';

var transferIcon$1 = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE2IDE4Ij48cGF0aCBkPSJNMTUuNSA0LjVsLTQtNGMtLjMtLjMtLjgtLjMtMS4xIDBzLS4zLjggMCAxLjFsMi43IDIuN0g2Yy0uNCAwLS44LjMtLjguN3MuNC44LjguOGg3LjJsLTIuNyAyLjdjLS4zLjMtLjMuOCAwIDEuMS4xLjEuMy4yLjUuMnMuNC0uMS41LS4ybDQtNGMuMy0uNC4zLS44IDAtMS4xek0xMCAxMi4ySDIuOGwyLjctMi43Yy4zLS4zLjMtLjggMC0xLjFzLS44LS4zLTEuMSAwbC00IDRjLS4xLjEtLjIuMy0uMi41cy4xLjQuMi41bDQgNGMuMS4xLjMuMi41LjJzLjQtLjEuNS0uMmMuMy0uMy4zLS44IDAtMS4xbC0yLjctMi43SDEwYy40IDAgLjgtLjMuOC0uOHMtLjQtLjYtLjgtLjZ6Ii8+PC9zdmc+';

var AgentChatTransfer = function AgentChatTransfer(_ref) {
  var isError = _ref.isError,
      disabled = _ref.disabled,
      transferOnly = _ref.transferOnly,
      searchTerm = _ref.searchTerm,
      onSearch = _ref.onSearch,
      onTransfer = _ref.onTransfer,
      onAddAgent = _ref.onAddAgent,
      onCancel = _ref.onCancel,
      errorMessage = _ref.errorMessage,
      agents = _ref.agents;
  var blockName = 'ch-transfer';
  var stages = {
    search: 'search',
    details: 'details'
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(stages.search),
      _useState4 = _slicedToArray(_useState3, 2),
      stage = _useState4[0],
      setStage = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      agent = _useState6[0],
      setAgent = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      top = _useState8[0],
      setTop = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isGroupChat = _useState10[0],
      setIsGroupChat = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      inProgress = _useState12[0],
      setInProgress = _useState12[1];

  var _useState13 = useState(''),
      _useState14 = _slicedToArray(_useState13, 2),
      message = _useState14[0],
      setMessage = _useState14[1];

  var handleMessageChange = function handleMessageChange(_, value) {
    setMessage(value);
  };

  var togglePopover = function togglePopover() {
    return setIsOpen(!isOpen);
  };

  var handleAgentSelection = function handleAgentSelection(isGroup) {
    return function (selectedAgent, topPosition) {
      setAgent(selectedAgent);
      setIsGroupChat(isGroup);
      setTop(topPosition);
      setStage(stages.details);
    };
  };

  var resetToSearch = function resetToSearch() {
    setStage(stages.search);
    setAgent(null);
    setMessage('');
    setInProgress(false);
    onCancel();
  };

  var backToPreviousStage = function backToPreviousStage() {
    setInProgress(false);
    onCancel();
  };

  var handleCancel = function handleCancel() {
    setIsOpen(false);
    resetToSearch();
  };

  var handleTransfer = function handleTransfer() {
    if (isGroupChat) {
      onAddAgent({
        agent: agent,
        message: message
      });
    } else {
      onTransfer({
        agent: agent,
        message: message
      });
    }

    setInProgress(true);
  };

  var renderError = function renderError() {
    return React__default.createElement("div", {
      className: "".concat(blockName, "__error-wrapper")
    }, React__default.createElement("div", {
      className: "".concat(blockName, "__error-message")
    }, errorMessage), React__default.createElement(ButtonsContainer, {
      className: cx("".concat(blockName, "__controls"), "".concat(blockName, "__controls--to-bottom"))
    }, React__default.createElement(SvgButton, {
      src: backIcon,
      onClick: backToPreviousStage
    }), React__default.createElement(Button$1, {
      kind: "cancel",
      onClick: resetToSearch
    }, "Search for new agent")));
  };

  var renderStage = function renderStage() {
    if (stage === stages.search) {
      return React__default.createElement(ScrollContainer, {
        className: cx("".concat(blockName, "__agent-list"), _defineProperty({}, "".concat(blockName, "__agent-list--hidden"), agent))
      }, agents.length > 0 && agents.map(function (a, i) {
        var inactiveAgent = a.status === Constants.UserStatuses.Offline;
        return React__default.createElement(AgentChatTransferUser, {
          key: i,
          agent: a,
          disabled: inactiveAgent,
          onAddAgent: handleAgentSelection(true),
          onTransfer: handleAgentSelection(false),
          transferOnly: transferOnly
        });
      }));
    }

    return React__default.createElement(React__default.Fragment, null, React__default.createElement(AgentChatTransferUser, {
      oldTop: top,
      agent: agent,
      disabled: true
    }), React__default.createElement("div", {
      className: "".concat(blockName, "__details")
    }, React__default.createElement("div", {
      className: "".concat(blockName, "__message")
    }, React__default.createElement(TextArea$1, {
      rows: 3,
      value: message,
      onChange: handleMessageChange,
      autosize: false,
      disabled: inProgress,
      kind: "gray",
      placeholder: "Include message for agent here."
    })), React__default.createElement(ButtonsContainer, {
      className: cx("".concat(blockName, "__controls"), _defineProperty({}, "".concat(blockName, "__controls--in-progress"), inProgress))
    }, React__default.createElement(Button$1, {
      className: "".concat(blockName, "__cancel"),
      onClick: handleCancel,
      kind: "cancel",
      narrow: true
    }, "Cancel"), React__default.createElement(Button$1, {
      className: "".concat(blockName, "__send"),
      onClick: handleTransfer,
      disabled: inProgress,
      narrow: true
    }, "Send"))));
  };

  var renderPopoverContent = function renderPopoverContent() {
    var _cx3;

    var hideHeader = !isError && stage === stages.search;
    return React__default.createElement("div", {
      className: cx("".concat(blockName, "__wrapper"), (_cx3 = {}, _defineProperty(_cx3, "".concat(blockName, "__wrapper--stage-error"), isError), _defineProperty(_cx3, "".concat(blockName, "__wrapper--stage-").concat(stage), stage && !isError), _cx3))
    }, React__default.createElement(AgentChatTransferHeader, {
      inProgress: inProgress,
      isError: isError,
      isGroupChat: isGroupChat,
      isHidden: hideHeader
    }), React__default.createElement(SvgButton, {
      className: "".concat(blockName, "__close-svg"),
      onClick: handleCancel,
      src: closeIcon,
      disabled: stage !== stages.search && !isError,
      width: "8px",
      height: "8px",
      kind: "gray"
    }), React__default.createElement("div", {
      className: "".concat(blockName, "__search")
    }, React__default.createElement(SearchField$1, {
      value: searchTerm,
      onChange: onSearch,
      placeholder: "Search"
    })), isError ? renderError() : renderStage());
  };

  return React__default.createElement(Popover, {
    containerClassName: "".concat(blockName, "__popover"),
    isOpen: isOpen,
    position: "bottom",
    content: renderPopoverContent(),
    padding: 8
  }, React__default.createElement(SvgButton, {
    className: cx("".concat(blockName, "__btn"), _defineProperty({}, "".concat(blockName, "__btn--open"), isOpen)),
    src: transferIcon$1,
    disabled: disabled,
    kind: "widget",
    onClick: togglePopover
  }));
};

AgentChatTransfer.propTypes = {
  onTransfer: PropTypes.func.isRequired,
  onAddAgent: PropTypes.func,
  transferOnly: PropTypes.bool,
  isError: PropTypes.bool,
  disabled: PropTypes.bool,
  errorMessage: PropTypes.string,
  searchTerm: PropTypes.string,
  onSearch: PropTypes.func,
  onCancel: PropTypes.func,
  agents: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number])))
};
AgentChatTransfer.defaultProps = {
  transferOnly: true,
  isError: false,
  disabled: false,
  errorMessage: 'An error has occured',
  searchTerm: '',
  agents: [],
  onCancel: noop
};

var AgentEndChatOption = function AgentEndChatOption(_ref) {
  var option = _ref.option,
      onOptionClick = _ref.onOptionClick,
      renderOption = _ref.renderOption,
      autofocus = _ref.autofocus,
      className = _ref.className;
  var optionRef = useRef(null);
  useEffect(function () {
    if (option.autofocus || autofocus) {
      setTimeout(function () {
        optionRef.current.focus();
      }, 0);
    }
  }, [option.autofocus, autofocus]);
  return React__default.createElement("div", {
    className: className,
    onClick: onOptionClick,
    onKeyDown: keyboardClick(onOptionClick),
    tabIndex: 0,
    role: "button",
    ref: optionRef
  }, renderOption ? renderOption(option) : option.label);
};

AgentEndChatOption.propTypes = {
  className: PropTypes.string,
  option: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool])).isRequired,
  onOptionClick: PropTypes.func.isRequired,
  renderOption: PropTypes.func,
  autofocus: PropTypes.bool
};
AgentEndChatOption.defaultProps = {
  className: '',
  autofocus: false
};

var AgentEndChat = function AgentEndChat(_ref) {
  var title = _ref.title,
      options = _ref.options,
      onOptionClick = _ref.onOptionClick,
      renderSection = _ref.renderSection,
      renderOption = _ref.renderOption,
      autofocus = _ref.autofocus;
  var blockName = 'ch-end-chat';

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var toggleMenu = function toggleMenu() {
    return setIsOpen(!isOpen);
  };

  var isMultiOption = !!options;

  var defaultRenderSection = function defaultRenderSection(section, sectionIndex) {
    return React__default.createElement(React__default.Fragment, null, section.title && React__default.createElement("div", {
      className: "".concat(blockName, "__section-title")
    }, section.title), section.options.map(function (option, j) {
      var handleOptionClick = function handleOptionClick() {
        if (isOpen) setIsOpen(false);
        onOptionClick(option);
      };

      var isAutofocus = autofocus && j === 0 && sectionIndex === 0;
      return React__default.createElement(AgentEndChatOption, {
        className: "".concat(blockName, "__option"),
        key: "option_".concat(j),
        onOptionClick: handleOptionClick,
        option: option,
        autofocus: isAutofocus,
        index: j,
        renderOption: renderOption
      });
    }));
  };

  var renderPopoverContent = function renderPopoverContent() {
    return React__default.createElement("div", {
      className: "".concat(blockName, "__options")
    }, options.map(function (section, i) {
      return React__default.createElement("div", {
        className: "".concat(blockName, "__section"),
        key: "section_".concat(i)
      }, renderSection ? renderSection(section) : defaultRenderSection(section, i));
    }));
  };

  var renderEndChatButton = function renderEndChatButton() {
    var _cx;

    return React__default.createElement(Button$1, {
      className: cx("".concat(blockName, "__btn"), (_cx = {}, _defineProperty(_cx, "".concat(blockName, "__btn--multi-option"), isMultiOption), _defineProperty(_cx, "".concat(blockName, "__btn--open"), isOpen), _cx)),
      kind: "choice",
      onClick: isMultiOption ? toggleMenu : onOptionClick
    }, isMultiOption ? title.multiOption : title.singleOption);
  };

  return isMultiOption ? React__default.createElement(Popover, {
    containerClassName: "".concat(blockName, "__popover"),
    isOpen: isOpen,
    onClickOutside: toggleMenu,
    position: "top",
    content: renderPopoverContent(),
    padding: 16
  }, renderEndChatButton()) : renderEndChatButton();
};

AgentEndChat.propTypes = {
  title: PropTypes.shape({
    multiOption: PropTypes.string,
    singleOption: PropTypes.string
  }),
  options: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool])))
  })),
  onOptionClick: PropTypes.func.isRequired,
  renderSection: PropTypes.func,
  renderOption: PropTypes.func,
  autofocus: PropTypes.bool
};
AgentEndChat.defaultProps = {
  title: {
    multiOption: 'End chat and',
    singleOption: 'End chat'
  },
  autofocus: true
};

var Chip = function Chip(_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      children = _ref.children,
      onClick = _ref.onClick;
  return React__default.createElement("div", {
    role: "button",
    tabIndex: 0,
    className: cx('ch-chip', className),
    onClick: onClick,
    onKeyDown: keyboardClick(onClick)
  }, icon && React__default.createElement("div", {
    className: "ch-chip__icon"
  }, React__default.createElement(Svg, {
    src: icon
  })), React__default.createElement("span", {
    className: "ch-chip__content"
  }, children));
};

Chip.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  children: PropTypes.oneOfType([PropTypes.string]).isRequired,
  onClick: PropTypes.func
};
Chip.defaultProps = {
  className: '',
  onClick: noop
};

var CustomerChatInput = function CustomerChatInput(_ref) {
  var className = _ref.className,
      inputClassName = _ref.inputClassName,
      rows = _ref.rows,
      autosize = _ref.autosize,
      onChange = _ref.onChange,
      onSendMessage = _ref.onSendMessage,
      placeholder = _ref.placeholder,
      value = _ref.value,
      maxHeight = _ref.maxHeight,
      initialHeight = _ref.initialHeight,
      other = _objectWithoutProperties(_ref, ["className", "inputClassName", "rows", "autosize", "onChange", "onSendMessage", "placeholder", "value", "maxHeight", "initialHeight"]);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      height = _useState2[0],
      setHeight = _useState2[1];

  var inputRef = useRef(null);

  var resetHeight = function resetHeight() {
    inputRef.current.style.height = 'auto';
    inputRef.current.overflow = 'initial';
  };

  var handleChange = function handleChange(event) {
    var inputValue = event.target.value;
    onChange(inputValue);
    if (inputValue === '') resetHeight();
  };

  var handleSendMessage = function handleSendMessage(inputValue) {
    if (validateInput({
      inputValue: inputValue
    })) {
      onSendMessage(cleanupInput(inputValue));
      resetHeight();
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    var altKey = event.altKey,
        ctrlKey = event.ctrlKey,
        shiftKey = event.shiftKey,
        inputValue = event.target.value;

    if (event.key === 'Enter') {
      event.preventDefault();

      if (altKey || ctrlKey || shiftKey) {
        onChange("".concat(inputValue, "\n"));
      } else {
        handleSendMessage(inputValue);
      }
    }
  };

  useEffect(function () {
    if (!autosize || inputRef.current === null) return;
    setHeight(inputRef.current.scrollHeight);
  }, [autosize, value]);
  useEffect(function () {
    if (height !== null) {
      if (maxHeight && height > maxHeight) {
        inputRef.current.style.height = maxHeight;
        inputRef.current.overflow = 'scroll';
      } else {
        inputRef.current.style.height = "".concat(height, "px");
      }

      inputRef.current.scrollTop = height;
    }
  }, [height, maxHeight]);
  return React__default.createElement("div", {
    className: cx('ch-customer-chat-input', className)
  }, React__default.createElement("textarea", _extends({}, other, {
    className: cx('ch-customer-chat-input__textarea', inputClassName),
    type: "text",
    placeholder: placeholder,
    value: value,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    rows: rows,
    ref: inputRef
  })));
};

CustomerChatInput.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  rows: PropTypes.number,
  autosize: PropTypes.bool,
  onChange: PropTypes.func,
  onSendMessage: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  maxHeight: PropTypes.number,
  initialHeight: PropTypes.number
};
CustomerChatInput.defaultProps = {
  value: '',
  placeholder: 'Type your message and press Enter to send',
  onChange: function onChange() {},
  onSendMessage: function onSendMessage() {},

  /** Native <textarea> prop, works as calculated height (or min-height, if autosize is enabled). */
  rows: 2,
  autosize: true
};

var ToggleArea = function ToggleArea(_ref) {
  var className = _ref.className,
      children = _ref.children,
      show = _ref.show;
  var blockName = 'toggle-area';
  return show && React__default.createElement("div", {
    className: cx(blockName, className)
  }, children);
};

ToggleArea.propTypes = {
  className: PropTypes.string,
  children: PropTypes.element,
  show: PropTypes.bool
};
ToggleArea.defaultProps = {
  className: '',
  show: false
};

var addDescriptionIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDEyIDE0Ij48cGF0aCBkPSJNLjcgMTJjLS4yIDAtLjQtLjEtLjUtLjItLjEtLjEtLjItLjMtLjItLjVWMS45YzAtLjIuMS0uNC4yLS41LjEtLjEuMy0uMi41LS4yaDZsLS43LjdILjh2OS40aDguNlY2LjVsLjgtLjd2NS41YzAgLjQtLjMuNy0uNy44TC43IDEyeiIvPjxwYXRoIGQ9Ik00LjEgNS41bC0uMi4yLS4xLjFjMCAuNC0uMyAxLjQtLjcgMi43IDAgLjEgMCAuMi4xLjMgMCAuMS4xLjIuMi4yaC4yYzEtLjMgMS45LS42IDIuNi0uOWguMmMxLjgtMS44IDMuNS0zLjQgNC45LTQuOWwuMy0uM2MuMi0uNC40LS44LjQtMS4yIDAtLjUtLjMtLjktLjYtMS4yLS4zLS4zLS43LS41LTEuMS0uNS0uNSAwLS45LjItMS4yLjUtLjUuNS0uOSAxLTEuNCAxLjQtLjguOC0yIDIuMS0zLjYgMy42em01LjUtNC40Yy4yLS4yLjQtLjMuNy0uMy4yIDAgLjQuMS42LjMuMi4yLjMuNC4zLjYgMCAuMy0uMi41LS40LjctLjEuMi0xIDEuMS0yLjcgMi43TDYgNy4ybC0uMi4yYy0uMi4xLS43LjItMS40LjVMNCA4Yy4yLS41LjMtMSAuNC0xLjMuMS0uMi4xLS40LjItLjVsNS01LjF6Ii8+PC9zdmc+';

var removeDescriptionIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDEyIDE0Ij48cGF0aCBkPSJNOS40IDYuNXYyLjNoLjd2LTN6TTYuNiAxMS4zSC44VjEuOUg2bC44LS43aC02Yy0uMiAwLS40LjEtLjUuMi0uMi4xLS4zLjMtLjMuNXY5LjRjMCAuMi4xLjQuMi41LjEuMi4zLjIuNS4yaDUuOXYtLjd6Ii8+PHBhdGggZD0iTTQuMSA1LjVsLS4yLjItLjEuMWMwIC40LS4zIDEuNC0uNyAyLjcgMCAuMSAwIC4yLjEuMyAwIC4xLjEuMi4yLjJoLjJjMS0uMyAxLjktLjYgMi42LS45aC4yYzEuOC0xLjggMy41LTMuNCA0LjktNC45bC4zLS4zYy4yLS40LjQtLjguNC0xLjIgMC0uNS0uMy0uOS0uNi0xLjItLjMtLjMtLjctLjUtMS4xLS41LS41IDAtLjkuMi0xLjIuNS0uNS41LS45IDEtMS40IDEuNC0uOC44LTIgMi4xLTMuNiAzLjZ6bTUuNS00LjRjLjItLjIuNC0uMy43LS4zLjIgMCAuNC4xLjYuMy4yLjIuMy40LjMuNiAwIC4zLS4yLjUtLjQuNy0uMS4yLTEgMS4xLTIuNyAyLjdMNiA3LjJsLS4yLjJjLS4yLjEtLjcuMi0xLjQuNUw0IDhjLjItLjUuMy0xIC40LTEuMy4xLS4yLjEtLjQuMi0uNWw1LTUuMXpNMTIgMTBsLS41LS41LTEuOCAxLjdMOCA5LjVsLS41LjUgMS43IDEuNy0xLjcgMS44LjUuNSAxLjctMS43IDEuOCAxLjcuNS0uNS0xLjctMS44eiIvPjwvc3ZnPg==';

var AgentChatInput = function AgentChatInput(_ref) {
  var className = _ref.className,
      inputClassName = _ref.inputClassName,
      onInputChange = _ref.onInputChange,
      onSendMessage = _ref.onSendMessage,
      value = _ref.value,
      endChatOptions = _ref.endChatOptions,
      onEndChatOptionClick = _ref.onEndChatOptionClick,
      onSearch = _ref.onSearch,
      onTransfer = _ref.onTransfer,
      onTransferCancel = _ref.onTransferCancel,
      onAddAgent = _ref.onAddAgent,
      transferOnly = _ref.transferOnly,
      isTransferEnabled = _ref.isTransferEnabled,
      isTransferError = _ref.isTransferError,
      transferErrorMessage = _ref.transferErrorMessage,
      searchTerm = _ref.searchTerm,
      renderSection = _ref.renderSection,
      renderOption = _ref.renderOption,
      agents = _ref.agents,
      chatDescription = _ref.chatDescription,
      onChatDescriptionChange = _ref.onChatDescriptionChange;
  var blockName = 'ch-agent-chat-input';

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      descriptionVisible = _useState2[0],
      setDescriptionVisible = _useState2[1];

  var descriptionTogglerTitle = descriptionVisible ? 'Remove Description' : 'Add Description';
  var descriptionTogglerIcon = descriptionVisible ? removeDescriptionIcon : addDescriptionIcon;

  var toggleDescription = function toggleDescription() {
    var newValue = !descriptionVisible;
    setDescriptionVisible(newValue);

    if (!newValue) {
      onChatDescriptionChange();
    }
  };

  return React__default.createElement("div", {
    className: cx(blockName, className)
  }, React__default.createElement(CustomerChatInput, {
    className: cx("".concat(blockName, "__input"), inputClassName),
    withBorder: false,
    onChange: onInputChange,
    onSendMessage: onSendMessage,
    value: value
  }), React__default.createElement(ToggleArea, {
    show: descriptionVisible
  }, React__default.createElement("textarea", {
    className: "".concat(blockName, "__description__textarea"),
    type: "text",
    placeholder: "Describe the chat...",
    value: chatDescription,
    rows: 6,
    onChange: onChatDescriptionChange
  })), React__default.createElement("div", {
    className: "".concat(blockName, "__controls")
  }, React__default.createElement(AgentEndChat, {
    options: endChatOptions,
    onOptionClick: onEndChatOptionClick,
    renderSection: renderSection,
    renderOption: renderOption
  }), React__default.createElement(Chip, {
    icon: descriptionTogglerIcon,
    onClick: toggleDescription
  }, descriptionTogglerTitle), React__default.createElement("div", {
    className: "".concat(blockName, "__controls__span")
  }), isTransferEnabled && onTransfer && React__default.createElement(AgentChatTransfer, {
    onTransfer: onTransfer,
    onCancel: onTransferCancel,
    onAddAgent: onAddAgent,
    onSearch: onSearch,
    searchTerm: searchTerm,
    agents: agents,
    transferOnly: transferOnly,
    isError: isTransferError,
    errorMessage: transferErrorMessage
  })));
};

AgentChatInput.propTypes = _objectSpread2({}, AgentChatTransfer.propTypes, {
  className: PropTypes.string,
  value: PropTypes.string,
  onSendMessage: PropTypes.func,
  endChatTitle: AgentEndChat.propTypes.title,
  endChatOptions: AgentEndChat.propTypes.options,
  onEndChatOptionClick: PropTypes.func.isRequired,
  renderSection: PropTypes.func,
  renderOption: PropTypes.func,
  agents: AgentChatTransfer.propTypes.agents,
  chatDescription: PropTypes.string,
  onChatDescriptionChange: PropTypes.func
});
AgentChatInput.defaultProps = {
  className: '',
  value: '',
  onChatDescriptionChange: noop
};

var WithNewLines = function WithNewLines(_ref) {
  var children = _ref.children;
  if (typeof children !== 'string') return children;
  return map(split(children, '\n'), function (line, i) {
    return React__default.createElement("div", {
      key: i
    }, line || "\0");
  });
};

WithNewLines.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.string), PropTypes.element])
};
WithNewLines.defaultProps = {
  children: ''
};

var ExtraInfo = function ExtraInfo(_ref) {
  var _cx;

  var className = _ref.className,
      kind = _ref.kind,
      noMargin = _ref.noMargin,
      alignRight = _ref.alignRight,
      label = _ref.label,
      value = _ref.value,
      href = _ref.href,
      onClick = _ref.onClick;
  var blockName = 'ch-extra-info';
  var finalClassName = cx(blockName, (_cx = {}, _defineProperty(_cx, "".concat(blockName, "--").concat(kind), kind), _defineProperty(_cx, "".concat(blockName, "--no-margin"), noMargin), _defineProperty(_cx, "".concat(blockName, "--align-right"), alignRight), _defineProperty(_cx, "".concat(blockName, "--button"), !!onClick), _cx), className);

  var getContent = function getContent() {
    if (href) {
      return React__default.createElement("a", {
        className: cx("".concat(blockName, "__value"), "".concat(blockName, "__value--link")),
        href: href
      }, React__default.createElement(WithNewLines, null, value));
    }

    if (onClick) {
      return React__default.createElement("div", {
        className: "".concat(blockName, "__value"),
        onClick: onClick,
        onKeyDown: keyboardClick(onClick)
      }, React__default.createElement(WithNewLines, null, value));
    }

    return React__default.createElement("div", {
      className: "".concat(blockName, "__value")
    }, React__default.createElement(WithNewLines, null, value));
  };

  return React__default.createElement("div", {
    className: finalClassName
  }, React__default.createElement("div", {
    className: "".concat(blockName, "__label")
  }, label), getContent());
};

ExtraInfo.propTypes = {
  className: PropTypes.string,
  kind: PropTypes.oneOf(['light', 'dark', 'interaction']),
  noMargin: PropTypes.bool,
  alignRight: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  href: PropTypes.string,
  onClick: PropTypes.func
};
ExtraInfo.defaultProps = {
  className: '',
  kind: 'dark',
  noMargin: false,
  alignRight: false,
  label: '',
  value: '',
  href: ''
};

var AgentChatInvitation = function AgentChatInvitation(_ref) {
  var className = _ref.className,
      isGroup = _ref.isGroup,
      agent = _ref.agent,
      contact = _ref.contact,
      account = _ref.account,
      question = _ref.question,
      message = _ref.message,
      onDismiss = _ref.onDismiss,
      onAccept = _ref.onAccept;
  var blockName = 'ch-chat-invitation';
  var withExtraInfo = contact || account || question;
  var headerText = "Incoming ".concat(isGroup ? 'Group' : 'Transfer', " Chat").concat(withExtraInfo ? ' From:' : '');
  var agentInfo = "".concat(agent.name, ", ").concat(agent.department);
  return React__default.createElement("div", {
    className: cx(blockName, className)
  }, React__default.createElement("div", {
    className: "".concat(blockName, "__header")
  }, React__default.createElement("div", {
    className: "".concat(blockName, "__header-text")
  }, headerText), withExtraInfo && React__default.createElement("div", {
    className: "".concat(blockName, "__subheader")
  }, agentInfo)), React__default.createElement("div", {
    className: "".concat(blockName, "__content")
  }, !withExtraInfo && React__default.createElement(ExtraInfo, {
    label: "Requesting Agent",
    value: agentInfo,
    kind: "light"
  }), contact && React__default.createElement("div", {
    className: cx("".concat(blockName, "__contact"), _defineProperty({}, "".concat(blockName, "__contact--with-account"), account))
  }, React__default.createElement(ExtraInfo, {
    className: "".concat(blockName, "__contact-detail"),
    label: "Contact Name",
    value: contact,
    kind: "light"
  }), account && React__default.createElement(ExtraInfo, {
    className: "".concat(blockName, "__contact-detail"),
    label: "Account",
    value: account.name,
    href: account.href,
    kind: "light"
  })), question && React__default.createElement(ExtraInfo, {
    label: "question",
    value: question,
    kind: "light"
  }), message && React__default.createElement(ExtraInfo, {
    label: "message from agent",
    value: React__default.createElement(TextArea$1, {
      rows: 3,
      disabled: true,
      value: message,
      kind: "gray"
    }),
    kind: "light"
  }), React__default.createElement(ButtonsContainer, {
    className: "".concat(blockName, "__controls")
  }, React__default.createElement(Button$1, {
    className: "".concat(blockName, "__button"),
    onClick: onDismiss,
    narrow: true,
    kind: "cancel"
  }, "Dismiss"), React__default.createElement(Button$1, {
    className: "".concat(blockName, "__button"),
    onClick: onAccept,
    narrow: true
  }, "Accept"))));
};

AgentChatInvitation.propTypes = {
  agent: PropTypes.shape({
    name: PropTypes.string,
    department: PropTypes.string
  }),
  onDismiss: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  className: PropTypes.string,
  isGroup: PropTypes.bool,
  contact: PropTypes.string,
  account: PropTypes.shape({
    name: PropTypes.string,
    href: PropTypes.string
  }),
  question: PropTypes.string,
  message: PropTypes.string
};
AgentChatInvitation.defaultProps = {
  className: '',
  isGroup: false,
  question: '',
  message: '',
  agent: {}
};

var CustomerFormField = function CustomerFormField(_ref) {
  var className = _ref.className,
      inputClassName = _ref.inputClassName,
      name = _ref.name,
      type = _ref.type,
      placeholder = _ref.placeholder,
      isError = _ref.isError,
      errorMessage = _ref.errorMessage,
      onChange = _ref.onChange,
      value = _ref.value,
      other = _objectWithoutProperties(_ref, ["className", "inputClassName", "name", "type", "placeholder", "isError", "errorMessage", "onChange", "value"]);

  var blockName = 'ch-customer-form-field';

  var renderErrorMessage = function renderErrorMessage() {
    if (errorMessage) return errorMessage;
    var defaultErrorMessage = 'Please fill in this field';
    var validOrYour = value === '' ? 'your' : 'a valid';
    var errorMessages = {
      name: "Please enter ".concat(validOrYour, " name"),
      email: "Please enter ".concat(validOrYour, " email address"),
      phone: "Please enter ".concat(validOrYour, " phone number"),
      message: 'Please enter a message',
      question: 'Please answer this question'
    };
    return errorMessages[name] || defaultErrorMessage;
  };

  var renderInput = function renderInput() {
    if (name === 'name' || name === 'email' || name === 'phone') {
      var autoComplete = name === 'phone' ? 'tel' : name;
      return React__default.createElement(TextField$1, _extends({
        className: inputClassName,
        value: value,
        name: name,
        placeholder: placeholder,
        isError: isError,
        onChange: onChange,
        autoComplete: autoComplete
      }, other));
    }

    return React__default.createElement(TextArea$1, _extends({
      className: inputClassName,
      value: value,
      name: name,
      placeholder: placeholder,
      isError: isError,
      onChange: onChange,
      rows: 4,
      autosize: false
    }, other));
  };

  var onSubmit = function onSubmit(event) {
    event.stopPropagation();
    event.preventDefault();
    return false;
  };

  return React__default.createElement("form", {
    className: cx(blockName, className),
    onSubmit: onSubmit
  }, renderInput(), React__default.createElement("div", {
    className: "".concat(blockName, "__error")
  }, isError && renderErrorMessage()));
};

CustomerFormField.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  isError: PropTypes.bool,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string
};
CustomerFormField.defaultProps = {
  className: '',
  inputClassName: ''
};

var CustomerForm = function CustomerForm(_ref) {
  var className = _ref.className,
      fieldClassName = _ref.fieldClassName,
      inputClassName = _ref.inputClassName,
      title = _ref.title,
      button = _ref.button,
      fields = _ref.fields,
      errors = _ref.errors,
      onSubmit = _ref.onSubmit,
      onBlur = _ref.onBlur;
  var blockName = 'ch-customer-form';

  var _useState = useState(function () {
    return fields.reduce(function (acc, _ref2) {
      var key = _ref2.key,
          _ref2$value = _ref2.value,
          value = _ref2$value === void 0 ? '' : _ref2$value;
      var isError = errors.some(function (err) {
        return err.body ? err.body.key === key : false;
      });
      return _objectSpread2({}, acc, _defineProperty({}, key, {
        value: value,
        isError: isError
      }));
    }, {});
  }),
      _useState2 = _slicedToArray(_useState, 2),
      result = _useState2[0],
      setResult = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isSending = _useState4[0],
      setIsSending = _useState4[1];

  var handleChange = function handleChange(_ref3) {
    var target = _ref3.target;
    var value = target.value,
        name = target.name;
    setResult(_objectSpread2({}, result, _defineProperty({}, name, {
      value: value
    })));
  };

  var validateResult = function validateResult() {
    var isValid = true;
    var updatedResult = keys(result).reduce(function (acc, name) {
      var value = result[name].value;
      var isValidValue = validateInput({
        value: value,
        name: name
      });

      if (isValidValue === false) {
        isValid = false;
      }

      return _objectSpread2({}, acc, _defineProperty({}, name, {
        value: value,
        isError: !isValidValue
      }));
    }, {});
    return [isValid, updatedResult];
  };

  var handleBlur = function handleBlur(event) {
    var _event$target = event.target,
        value = _event$target.value,
        name = _event$target.name;
    var isValid = validateInput({
      value: value,
      name: name
    });
    setResult(_objectSpread2({}, result, _defineProperty({}, name, {
      value: value,
      isError: !isValid
    })));
    onBlur(event);
  };

  var handleSubmit = function handleSubmit() {
    var _validateResult = validateResult(),
        _validateResult2 = _slicedToArray(_validateResult, 2),
        isValid = _validateResult2[0],
        updatedResult = _validateResult2[1];

    if (isValid) {
      setIsSending(true);
      var updatedFields = keys(updatedResult).reduce(function (acc, name) {
        var value = updatedResult[name].value;
        return _objectSpread2({}, acc, _defineProperty({}, name, cleanupInput(value)));
      }, {});
      onSubmit(updatedFields);
    }

    setResult(updatedResult);
  };

  var buttonText = button.text;
  return React__default.createElement("div", {
    className: cx(blockName, className)
  }, title && React__default.createElement("div", {
    className: "".concat(blockName, "__title")
  }, title), React__default.createElement("div", {
    className: "".concat(blockName, "__questions")
  }, fields.map(function (_ref4) {
    var key = _ref4.key,
        type = _ref4.type,
        placeholder = _ref4.placeholder;
    var _result$key = result[key],
        value = _result$key.value,
        isError = _result$key.isError;
    return React__default.createElement(CustomerFormField, {
      className: fieldClassName,
      inputClassName: inputClassName,
      key: key,
      name: key,
      type: type,
      placeholder: placeholder,
      value: value,
      isError: isError,
      onChange: handleChange,
      onBlur: handleBlur
    });
  })), React__default.createElement(Button$1, {
    className: "".concat(blockName, "__submit"),
    onClick: handleSubmit,
    loading: isSending
  }, buttonText));
};

CustomerForm.propTypes = {
  className: PropTypes.string,
  fieldClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  title: PropTypes.string,
  button: PropTypes.shape({
    text: PropTypes.string,
    style: PropTypes.shape({
      border: PropTypes.objectOf(PropTypes.string),
      colors: PropTypes.shape({
        background: PropTypes.string,
        "default": PropTypes.objectOf(PropTypes.string),
        foreground: PropTypes.string
      }),
      font: PropTypes.objectOf(PropTypes.string),
      images: PropTypes.objectOf(PropTypes.string),
      size: PropTypes.objectOf(PropTypes.string)
    })
  }),
  fields: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
  errors: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
  onSubmit: PropTypes.func,
  onBlur: PropTypes.func
};
CustomerForm.defaultProps = {
  className: '',
  fieldClassName: '',
  inputClassName: '',
  title: '',
  button: {
    text: 'Send and start chat'
  },
  onSubmit: function onSubmit() {},
  onBlur: function onBlur() {},
  errors: []
};

var DefaultAvatar =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DefaultAvatar, _React$PureComponent);

  function DefaultAvatar() {
    _classCallCheck(this, DefaultAvatar);

    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultAvatar).apply(this, arguments));
  }

  _createClass(DefaultAvatar, [{
    key: "render",
    value: function render() {
      return React__default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "13",
        height: "14.986",
        viewBox: "0 0 13 14.986"
      }, React__default.createElement("path", {
        fill: "#232649",
        d: "M10.431 7.03a5.2 5.2 0 0 0 .564-2.373v-.156.008c0-2.948-1.551-4.508-4.494-4.508S2.023 1.546 2.023 4.475v.165a5.248 5.248 0 0 0 .57 2.386l-.014-.03a2.645 2.645 0 0 0-2.552 3v1.978a2.58 2.58 0 0 0-.018.312 2.7 2.7 0 0 0 3.016 2.681H9.99a2.58 2.58 0 0 0 .307.018 2.7 2.7 0 0 0 2.681-3.016v-1.97a2.554 2.554 0 0 0 .021-.329 2.643 2.643 0 0 0-2.566-2.642zM6.499.994c2.38 0 3.487 1.111 3.482 3.491s-1.1 3.482-3.482 3.482-3.482-1.106-3.482-3.491S4.128.985 6.499.994zm3.665 6.5l-.113.144zm-7.165.134l-.113-.143zm8.978 4.357c0 1.373-.619 1.992-2 1.992H3.003c-1.373 0-1.992-.619-1.992-2V9.954c.009-1.373.628-1.987 2-1.987h.328a4.655 4.655 0 0 0 2.9 1.006c.091 0 .181 0 .27-.008h-.01c.078 0 .17.008.263.008A4.665 4.665 0 0 0 9.667 7.96l-.01.007h.328c1.373 0 1.992.619 1.992 2z",
        "data-name": "custom-new-contact"
      }));
    }
  }]);

  return DefaultAvatar;
}(React__default.PureComponent);

var getInitials = function getInitials(name) {
  var words = name.split(' ');
  var result;

  switch (true) {
    // name has a couple of words
    case words.length > 1:
      {
        var lastName = words.pop() || '';
        result = [name.charAt(0), lastName.charAt(0)].join('');
        break;
      }
    // one word name

    case name.length > 2:
      {
        result = name.charAt(0);
        break;
      }
    // one or two letters already

    default:
      {
        result = name;
      }
  }

  return result.toUpperCase();
};

var UserAvatar =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(UserAvatar, _React$PureComponent);

  function UserAvatar() {
    _classCallCheck(this, UserAvatar);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserAvatar).apply(this, arguments));
  }

  _createClass(UserAvatar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          className = _this$props.className,
          isMe = _this$props.isMe,
          src = _this$props.src,
          other = _objectWithoutProperties(_this$props, ["name", "className", "isMe", "src"]);

      var initials = name && getInitials(name);
      return React__default.createElement("div", _extends({
        className: cx('user-avatar', {
          'user-avatar--me': isMe,
          'user-avatar--responder': !isMe
        }, className),
        style: src ? {
          background: 'none'
        } : {}
      }, other), src ? React__default.createElement("img", {
        className: "user-avatar__image",
        src: src,
        alt: name
      }) : initials ? React__default.createElement("div", {
        className: "user-avatar__initials"
      }, initials) : React__default.createElement(DefaultAvatar, null));
    }
  }]);

  return UserAvatar;
}(React__default.PureComponent);

UserAvatar.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  src: PropTypes.string,
  isMe: PropTypes.bool
};
UserAvatar.defaultProps = {
  className: '',
  isMe: true
};

var ChatThreadMessage = function ChatThreadMessage(_ref) {
  var _cx;

  var className = _ref.className,
      name = _ref.name,
      src = _ref.src,
      timestamp = _ref.timestamp,
      text = _ref.text,
      isFirstMessage = _ref.isFirstMessage,
      isLastMessage = _ref.isLastMessage,
      isOutgoing = _ref.isOutgoing,
      isCustomer = _ref.isCustomer,
      timezone = _ref.timezone;
  var blockName = 'ch-chat-thread-message';

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showDetails = _useState2[0],
      setShowDetails = _useState2[1];

  var toggleDetails = function toggleDetails() {
    setShowDetails(!showDetails);
  };

  var displayDetails = !isFirstMessage && (isLastMessage || showDetails);
  var finalClassName = cx(blockName, (_cx = {}, _defineProperty(_cx, "".concat(blockName, "--first"), isFirstMessage), _defineProperty(_cx, "".concat(blockName, "--outgoing"), isOutgoing), _defineProperty(_cx, "".concat(blockName, "--incoming"), !isOutgoing), _defineProperty(_cx, "".concat(blockName, "--customer"), isCustomer), _defineProperty(_cx, "".concat(blockName, "--with-details"), displayDetails), _cx), className);
  var zonedTime = timezone ? utcToZonedTime(timestamp, validateTimezone(timezone)) : new Date(timestamp);
  var time = format(zonedTime, 'h:mm a');
  return React__default.createElement("div", {
    className: finalClassName
  }, isFirstMessage && React__default.createElement(UserAvatar, {
    className: "".concat(blockName, "__avatar"),
    name: name,
    src: src,
    isMe: !isOutgoing
  }), React__default.createElement("div", {
    className: "".concat(blockName, "__content")
  }, isFirstMessage && React__default.createElement("div", {
    className: "".concat(blockName, "__user")
  }, React__default.createElement("span", {
    className: "".concat(blockName, "__name")
  }, shortenName(name)), React__default.createElement("span", {
    className: "".concat(blockName, "__time")
  }, time)), React__default.createElement("div", {
    className: "".concat(blockName, "__text"),
    onClick: toggleDetails,
    onKeyDown: keyboardClick(toggleDetails)
  }, React__default.createElement(WithNewLines, null, text)), displayDetails && React__default.createElement("div", {
    className: "".concat(blockName, "__details")
  }, React__default.createElement("span", {
    className: "".concat(blockName, "__time")
  }, time))));
};

ChatThreadMessage.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string,
  isFirstMessage: PropTypes.bool,
  isLastMessage: PropTypes.bool,
  isOutgoing: PropTypes.bool,
  timestamp: PropTypes.string,
  timezone: PropTypes.string,
  text: PropTypes.string,
  name: PropTypes.string,
  isCustomer: PropTypes.bool
};
ChatThreadMessage.defaultProps = {
  className: '',
  src: '',
  isFirstMessage: false,
  isLastMessage: false,
  isOutgoing: false,
  isCustomer: false
};

var check = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDE1IDExIj48cGF0aCBmaWxsPSIjOTFDNjRGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC41Mi4yOWEuOTg2Ljk4NiAwIDAxMCAxLjM5NWwtOC42NyA4LjY3YS45ODguOTg4IDAgMDEtMS4zOTcgMEwuMjkgNi4xODhhLjk4Ni45ODYgMCAxMTEuMzk1LTEuMzk2TDUuMTUzIDguMjYgMTMuMTI0LjI4OWEuOTg2Ljk4NiAwIDAxMS4zOTUgMCIvPjwvc3ZnPg==';

var ChatThreadFormResult = function ChatThreadFormResult(_ref) {
  var className = _ref.className,
      fields = _ref.fields;
  var blockName = 'ch-chat-thread-form-result';
  return React__default.createElement("div", {
    className: cx(blockName, className)
  }, fields.map(function (_ref2, i) {
    var value = _ref2.value;
    return React__default.createElement("div", {
      key: i,
      className: "".concat(blockName, "__answer")
    }, React__default.createElement("div", {
      className: "".concat(blockName, "__text")
    }, React__default.createElement(WithNewLines, null, value)), React__default.createElement("div", {
      className: "".concat(blockName, "__check")
    }, React__default.createElement(Svg, {
      src: check,
      width: 12
    })));
  }));
};

ChatThreadFormResult.propTypes = {
  className: PropTypes.string,
  fields: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string))
};

var ChatThreadSystemMessage = function ChatThreadSystemMessage(_ref) {
  var className = _ref.className,
      text = _ref.text;
  return React__default.createElement("div", {
    className: cx('ch-chat-thread-system-message', className)
  }, text);
};

ChatThreadSystemMessage.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string
};
ChatThreadSystemMessage.defaultProps = {
  className: ''
};

var progress = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMS4yIDQiPjxjaXJjbGUgY3g9IjIiIGN5PSIyIiByPSIyIiBmaWxsPSIjNmI4MTlhIi8+PGNpcmNsZSBjeD0iMTAuNiIgY3k9IjIiIHI9IjIiIGZpbGw9IiM1NDY4N2YiLz48Y2lyY2xlIGN4PSIxOS4yIiBjeT0iMiIgcj0iMiIgZmlsbD0iIzNjNGY2NCIvPjwvc3ZnPg==';

var ChatThreadUserStatus = function ChatThreadUserStatus(_ref) {
  var className = _ref.className,
      text = _ref.text;
  var blockName = 'ch-chat-thread-user-status';
  return React__default.createElement("div", {
    className: cx(blockName, className)
  }, React__default.createElement("div", {
    className: "".concat(blockName, "__progress")
  }, React__default.createElement(Svg, {
    className: "".concat(blockName, "__svg"),
    src: progress,
    width: 22,
    height: 4
  })), React__default.createElement("div", {
    className: "".concat(blockName, "__text")
  }, text));
};

ChatThreadUserStatus.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string
};
ChatThreadUserStatus.defaultProps = {
  className: ''
};

var ChatThreadWorkingHours = function ChatThreadWorkingHours(_ref) {
  var className = _ref.className,
      _ref$workingHours = _ref.workingHours,
      day = _ref$workingHours.day,
      time = _ref$workingHours.time,
      breaks = _ref$workingHours.breaks;
  var blockName = 'ch-chat-thread-working-hours';

  var renderBreaks = function renderBreaks() {
    if (!size(breaks)) return undefined;
    return React__default.createElement("div", {
      className: "".concat(blockName, "__notification__hours__breaks")
    }, React__default.createElement("span", null, "Breaks: "), map(breaks, function (b, idx) {
      return React__default.createElement("span", {
        key: idx,
        className: "".concat(blockName, "__notification__hours__breaks__break")
      }, b);
    }));
  };

  return React__default.createElement("div", {
    className: cx(blockName, className)
  }, React__default.createElement("div", {
    className: "".concat(blockName, "__notification")
  }, React__default.createElement("span", {
    className: "".concat(blockName, "__notification__label")
  }, "Sorry, we are not working right now!"), React__default.createElement("div", {
    className: "".concat(blockName, "__notification__hours")
  }, React__default.createElement("span", {
    className: "".concat(blockName, "__notification__hours__comeback")
  }, "Please come back", /today/i.test(day) ? ' ' : ' on ', React__default.createElement("span", {
    className: "".concat(blockName, "__notification__hours__comeback__day")
  }, day)), React__default.createElement("span", {
    className: "".concat(blockName, "__notification__hours__time")
  }, "Working hours: ", time), renderBreaks())));
};

ChatThreadWorkingHours.propTypes = {
  className: PropTypes.string,
  workingHours: PropTypes.shape({
    day: PropTypes.string,
    time: PropTypes.string,
    breaks: PropTypes.arrayOf(PropTypes.string)
  }).isRequired
};
ChatThreadWorkingHours.defaultProps = {
  className: ''
};

var ChatThread =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ChatThread, _React$PureComponent);

  function ChatThread() {
    _classCallCheck(this, ChatThread);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChatThread).apply(this, arguments));
  }

  _createClass(ChatThread, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          isCustomer = _this$props.isCustomer,
          data = _this$props.data,
          jid = _this$props.jid,
          onSendMessage = _this$props.onSendMessage,
          isInteraction = _this$props.isInteraction,
          timezone = _this$props.timezone;
      return React__default.createElement("div", {
        className: cx('ch-chat-thread', className)
      }, data.map(function (message, i) {
        var type = message.type,
            name = message.name,
            src = message.src,
            timestamp = message.timestamp,
            content = message.content,
            from = message.from; // TODO: Review in favour of using a factory.

        switch (type) {
          case Constants.Routing.Types.form:
          case Constants.Routing.Types.formError:
            return React__default.createElement(CustomerForm, _extends({
              key: i
            }, content, {
              onSubmit: onSendMessage
            }));

          case Constants.Routing.Types.formResult:
            return React__default.createElement(ChatThreadFormResult, {
              key: i,
              fields: content.fields
            });

          case Constants.Routing.Types.system:
            return React__default.createElement(ChatThreadSystemMessage, {
              key: i,
              text: content
            });

          case Constants.Routing.Types.newParticipant:
            {
              var newParticipantName = content.name,
                  newParticipantJID = content.jid;

              if (newParticipantJID === jid) {
                return undefined;
              }

              return React__default.createElement(ChatThreadUserStatus, {
                key: i,
                text: "".concat(newParticipantName, " has joined the conversation")
              });
            }

          case Constants.Routing.Types.removedParticipant:
            {
              var removedParticipantName = content.name;
              return React__default.createElement(ChatThreadUserStatus, {
                key: i,
                text: "".concat(removedParticipantName, " has left the conversation")
              });
            }

          case Constants.Routing.Types.chatEnded:
            return React__default.createElement(ChatThreadUserStatus, {
              key: i,
              text: "The conversation has been finished"
            });

          case Constants.Routing.Types.transferInitialized:
            {
              var _content$from = content.from,
                  fromEmail = _content$from.jid,
                  fromName = _content$from.name,
                  toName = content.to.name,
                  isGroup = content.is_group_chat;
              var transferBy = fromEmail === jid ? 'You have' : "".concat(fromName, " has");
              var transferMessage = "".concat(transferBy, " initiated a transfer to ").concat(toName);
              var groupTransferMessage = "".concat(transferBy, " invited ").concat(toName, " to join the chat");
              return React__default.createElement(ChatThreadUserStatus, {
                key: i,
                text: isGroup ? groupTransferMessage : transferMessage
              });
            }

          case Constants.Routing.Types.transferExpired:
            return React__default.createElement(ChatThreadUserStatus, {
              key: i,
              text: "Transfer invitation expired"
            });

          case Constants.Routing.Types.transferAccepted:
            {
              var _content$to = content.to,
                  toEmail = _content$to.jid,
                  _toName = _content$to.name;
              var acceptMessage = "".concat(toEmail === jid ? 'You have' : "".concat(_toName, " has"), " accepted the invitation");
              return React__default.createElement(ChatThreadUserStatus, {
                key: i,
                text: acceptMessage
              });
            }

          case Constants.Routing.Types.transferDeclined:
            {
              var _fromName = content.from.name,
                  _content$to2 = content.to,
                  _toEmail = _content$to2.jid,
                  _toName2 = _content$to2.name,
                  declinedEmail = content.declined_by;
              var declinedBy = declinedEmail === _toEmail ? _toName2 : _fromName;
              var declinedOrCanceled = declinedEmail === _toEmail ? 'declined' : 'canceled';
              var declineMessage = "".concat(declinedEmail === jid ? 'You have' : "".concat(declinedBy, " has"), " ").concat(declinedOrCanceled, " the invitation");
              return React__default.createElement(ChatThreadUserStatus, {
                key: i,
                text: declineMessage
              });
            }

          case Constants.Routing.Types.schedule:
            return React__default.createElement(ChatThreadWorkingHours, _extends({
              key: i
            }, content));

          default:
            {
              // TODO: move logic related to `isOutgoing` bool to core @rhorokhov
              var isOutgoing = isInteraction ? !/^customer~~/.test(from) : jid === from;
              var previousMessage = data[i - 1];
              var nextMessage = data[i + 1];
              var isFirstMessage = previousMessage ? previousMessage.name !== name : true;
              var isLastMessage = nextMessage ? nextMessage.name !== name : true;
              return React__default.createElement(ChatThreadMessage, {
                key: i,
                name: name,
                src: src,
                isOutgoing: isOutgoing,
                isFirstMessage: isFirstMessage,
                isLastMessage: isLastMessage,
                timestamp: timestamp,
                text: content,
                isCustomer: isCustomer,
                timezone: timezone
              });
            }
        }
      }));
    }
  }]);

  return ChatThread;
}(React__default.PureComponent);

_defineProperty(ChatThread, "propTypes", {
  className: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    timestamp: PropTypes.string,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.object]),
    read: PropTypes.bool,
    name: PropTypes.string,
    from: PropTypes.string
  })).isRequired,
  jid: PropTypes.string.isRequired,
  isCustomer: PropTypes.bool,
  isInteraction: PropTypes.bool,
  timezone: PropTypes.string,
  onSendMessage: PropTypes.func // TODO: think about the necessity of a separate method like onSubmitForm here @rhorokhov

});

_defineProperty(ChatThread, "defaultProps", {
  isCustomer: false,
  isInteraction: false
});

var chatIcon$1 = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij48cGF0aCBkPSJNMy44IDEwLjVDMS43IDEwLjUgMCA4LjggMCA2LjdWNC4xQzAgMiAxLjcuMyAzLjguM2g2LjRDMTIuMy4zIDE0IDIgMTQgNC4xdjIuNWMwIDIuMS0xLjcgMy44LTMuOCAzLjhIN2wtMy4yIDMuMnYtMy4xeiIvPjwvc3ZnPg==';

var infoIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iOCIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik04IDE2Yy00LjQgMC04LTMuNi04LThzMy42LTggOC04IDggMy42IDggOC0zLjYgOC04IDh6TTggMS41QzQuNCAxLjUgMS41IDQuNCAxLjUgOHMyLjkgNi41IDYuNSA2LjUgNi41LTIuOSA2LjUtNi41UzExLjYgMS41IDggMS41eiIvPjxwYXRoIGQ9Ik03LjIgNy4yaDEuNXY1SDcuMnpNNy4yIDQuMmgxLjV2MS41SDcuMnoiLz48L3N2Zz4=';

var AgentChatWidgetHeader = function AgentChatWidgetHeader(_ref) {
  var className = _ref.className,
      customerName = _ref.customerName,
      customerInfo = _ref.customerInfo,
      onCustomerInfoItemClick = _ref.onCustomerInfoItemClick,
      isEnded = _ref.isEnded,
      isTyping = _ref.isTyping,
      status = _ref.status,
      onEndChatOptionClick = _ref.onEndChatOptionClick,
      isTransferEnabled = _ref.isTransferEnabled,
      transferOnly = _ref.transferOnly,
      onTransfer = _ref.onTransfer,
      onTransferCancel = _ref.onTransferCancel,
      isTransferError = _ref.isTransferError,
      transferErrorMessage = _ref.transferErrorMessage,
      transferIsDone = _ref.transferIsDone,
      searchTerm = _ref.searchTerm,
      onSearch = _ref.onSearch,
      agents = _ref.agents;
  var blockName = 'ch-agent-widget__header';

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isContactDetailsOpen = _useState2[0],
      setIsContactDetailsOpen = _useState2[1];

  var togglePopover = function togglePopover() {
    return setIsContactDetailsOpen(!isContactDetailsOpen);
  };

  var renderEndChatControl = useCallback(function () {
    var _cx;

    var btnClassName = cx("".concat(blockName, "__end"), (_cx = {}, _defineProperty(_cx, "".concat(blockName, "__end--ended"), isEnded), _defineProperty(_cx, "".concat(blockName, "__end--button"), !isEnded), _cx));
    return React__default.createElement("div", {
      className: "".concat(blockName, "__end-wrapper")
    }, isEnded ? React__default.createElement("div", {
      className: btnClassName
    }, "Ended") : React__default.createElement("div", {
      className: btnClassName,
      onClick: onEndChatOptionClick,
      onKeyDown: keyboardClick(onEndChatOptionClick),
      role: "button",
      tabIndex: 0
    }, "End"));
  }, [isEnded, onEndChatOptionClick]);
  var renderPopoverContent = useCallback(function () {
    if (keys(customerInfo).length === 0) return undefined;
    return keys(customerInfo).map(function (key) {
      var _customerInfo$key = customerInfo[key],
          id = _customerInfo$key.id,
          name = _customerInfo$key.name;
      return React__default.createElement(ExtraInfo, {
        className: "".concat(blockName, "__customer-info"),
        label: key,
        kind: "interaction",
        key: id,
        value: name,
        onClick: function onClick() {
          return onCustomerInfoItemClick(customerInfo[key]);
        }
      });
    });
  }, [customerInfo, onCustomerInfoItemClick]);
  var headerClassName = cx(blockName, _defineProperty({}, "".concat(blockName, "--ended"), isEnded), className);
  var controlClassName = "".concat(blockName, "__controls__element");
  var showTransfer = isTransferEnabled && !transferIsDone;
  return React__default.createElement("div", {
    className: headerClassName
  }, React__default.createElement("div", {
    className: "".concat(blockName, "__content--left")
  }, React__default.createElement(Svg, {
    className: "".concat(blockName, "__icon"),
    src: chatIcon$1,
    width: 14
  }), React__default.createElement("div", {
    className: "".concat(blockName, "__name")
  }, customerName), isTyping && React__default.createElement("div", {
    className: "".concat(blockName, "__typing")
  }, "Typing...")), React__default.createElement("div", {
    className: "".concat(blockName, "__content--right")
  }, React__default.createElement("div", {
    className: "".concat(blockName, "__controls--right")
  }, status && React__default.createElement("div", {
    className: "".concat(blockName, "__status")
  }, status), customerInfo && React__default.createElement(Popover, {
    containerClassName: "".concat(blockName, "__popover"),
    isOpen: isContactDetailsOpen,
    position: "bottom",
    content: renderPopoverContent(),
    padding: 8
  }, React__default.createElement(SvgButton, {
    className: controlClassName,
    kind: "widget",
    src: infoIcon,
    height: 16,
    onClick: togglePopover
  })), showTransfer && React__default.createElement(AgentChatTransfer, {
    className: controlClassName,
    disabled: isEnded,
    onTransfer: onTransfer,
    onAddAgent: onTransfer,
    transferOnly: transferOnly,
    isError: isTransferError,
    errorMessage: transferErrorMessage,
    searchTerm: searchTerm,
    onSearch: onSearch,
    onCancel: onTransferCancel,
    agents: agents
  })), renderEndChatControl()));
};

AgentChatWidgetHeader.propTypes = _objectSpread2({}, omit(AgentChatTransfer.propTypes, ['className']), {
  className: PropTypes.string,
  customerName: PropTypes.string,
  customerInfo: PropTypes.shape({
    contact: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string
    }),
    account: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string
    })
  }),
  onCustomerInfoItemClick: PropTypes.func,
  isEnded: PropTypes.bool,
  isTyping: PropTypes.bool,
  status: PropTypes.string,
  onEndChatOptionClick: PropTypes.func.isRequired,
  onTransfer: PropTypes.func,
  onTransferCancel: PropTypes.func,
  onSearch: PropTypes.func,
  transferOnly: PropTypes.bool,
  isTransferEnabled: PropTypes.bool,
  isTransferError: PropTypes.bool,
  transferIsDone: PropTypes.bool,
  searchTerm: PropTypes.string,
  transferErrorMessage: PropTypes.string,
  agents: AgentChatTransfer.propTypes.agents
});
AgentChatWidgetHeader.defaultProps = {
  className: '',
  customerName: 'Unknown Visitor',
  isTyping: false,
  isEnded: false,
  status: '',
  isTransferEnabled: true,
  transferIsDone: false,
  searchTerm: ''
};

var chatIcon$2 = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij48cGF0aCBkPSJNNC4zIDEyLjdMNyAxMGgyLjdjMS44IDAgMy4zLTEuNSAzLjMtMy4zVjQuNWMwLTEuOC0xLjUtMy4zLTMuMy0zLjNINC4zQzIuNSAxLjMgMSAyLjcgMSA0LjV2Mi4yQzEgOC41IDIuNSAxMCA0LjMgMTB2Mi43bTAgMWMtLjEgMC0uMyAwLS40LS4xLS40LS4yLS42LS41LS42LS45di0xLjhDMS40IDEwLjQgMCA4LjcgMCA2LjdWNC41QzAgMi4xIDEuOS4yIDQuMy4yaDUuNWMyLjQgMCA0LjMgMS45IDQuMyA0LjN2Mi4yYzAgMi40LTEuOSA0LjMtNC4zIDQuM0g3LjRMNSAxMy40Yy0uMi4yLS41LjMtLjcuM3oiLz48L3N2Zz4=';

var hideIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIj48cGF0aCBkPSJNNi4wMyAxMS4wM2wtNC42LTQuNSAxLjEtMS4xIDMuNSAzLjUgMy40LTMuNSAxLjEgMS4xeiIvPjxwYXRoIGQ9Ik02LjAzIDYuNTNsLTQuNi00LjUgMS4xLTEuMSAzLjUgMy41IDMuNC0zLjUgMS4xIDEuMXoiLz48L3N2Zz4=';

var AgentChatWidgetControls = function AgentChatWidgetControls(_ref) {
  var _cx;

  var className = _ref.className,
      isChatOpen = _ref.isChatOpen,
      isEnded = _ref.isEnded,
      placeholder = _ref.placeholder,
      inputValue = _ref.inputValue,
      showInput = _ref.showInput,
      onInputChange = _ref.onInputChange,
      onSendMessage = _ref.onSendMessage,
      onToggleChatClick = _ref.onToggleChatClick;
  var blockName = 'ch-agent-widget__controls';

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoaded = _useState2[0],
      setIsLoaded = _useState2[1];

  useEffect(function () {
    setTimeout(function () {
      return setIsLoaded(true);
    }, 0);
  }, []);
  var finalClassName = cx(blockName, (_cx = {}, _defineProperty(_cx, "".concat(blockName, "--with-input"), isChatOpen && !isEnded && showInput), _defineProperty(_cx, "".concat(blockName, "--with-top-border"), isChatOpen), _defineProperty(_cx, "".concat(blockName, "--with-value"), !!inputValue), _defineProperty(_cx, "".concat(blockName, "--is-loaded"), isLoaded), _cx), className);
  var showChatText = isEnded ? 'Show Conversation' : 'Chat Now';
  var hideChatText = "Hide ".concat(isEnded ? 'Conversation' : 'Chat');
  var inputVisible = showInput && isChatOpen && !isEnded;

  var renderLeftSection = function renderLeftSection() {
    if (inputVisible) {
      return React__default.createElement(CustomerChatInput, {
        className: "".concat(blockName, "__input"),
        inputClassName: "".concat(blockName, "__textarea"),
        value: inputValue,
        onChange: onInputChange,
        onSendMessage: onSendMessage,
        placeholder: placeholder,
        rows: 1,
        maxHeight: 100
      });
    }

    if (isChatOpen && isEnded) return hideChatText;
    return showChatText;
  };

  var handleLeftButtonClick = function handleLeftButtonClick() {
    if (!inputVisible) {
      onToggleChatClick();
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (!inputVisible) {
      keyboardClick(onToggleChatClick)(event);
    }
  };

  var leftSectionClassName = cx("".concat(blockName, "__left"), _defineProperty({}, "".concat(blockName, "__left--btn"), !isChatOpen));
  return React__default.createElement("div", {
    className: finalClassName
  }, React__default.createElement("div", {
    className: leftSectionClassName,
    onClick: handleLeftButtonClick,
    onKeyDown: handleKeyDown
  }, React__default.createElement(Svg, {
    className: "".concat(blockName, "__icon"),
    src: chatIcon$2,
    width: 12
  }), renderLeftSection()), React__default.createElement("div", {
    className: "".concat(blockName, "__middle")
  }, !inputVisible && 'Log Chat'), React__default.createElement(Chip, {
    className: "".concat(blockName, "__right"),
    onClick: onToggleChatClick,
    icon: hideIcon
  }, hideChatText));
};

AgentChatWidgetControls.propTypes = {
  className: PropTypes.string,
  isChatOpen: PropTypes.bool,
  isEnded: PropTypes.bool,
  placeholder: PropTypes.string,
  inputValue: PropTypes.string,
  showInput: PropTypes.bool,
  onInputChange: PropTypes.func,
  onSendMessage: PropTypes.func,
  onToggleChatClick: PropTypes.func
};
AgentChatWidgetControls.defaultProps = {
  className: '',
  isChatOpen: true,
  isEnded: false,
  placeholder: 'Press Enter to send chat reply',
  inputValue: '',
  showInput: true
};

var AgentChatWidgetFooter = function AgentChatWidgetFooter(_ref) {
  var className = _ref.className,
      onSaveClick = _ref.onSaveClick,
      onSaveToJunkClick = _ref.onSaveToJunkClick,
      onDescriptionClick = _ref.onDescriptionClick,
      saveDisabled = _ref.saveDisabled,
      saveToJunkDisabled = _ref.saveToJunkDisabled,
      isDescriptionOpen = _ref.isDescriptionOpen,
      renderLinkTo = _ref.renderLinkTo;
  var blockName = 'ch-agent-widget__footer';
  return React__default.createElement("div", {
    className: cx(blockName, className)
  }, React__default.createElement("div", {
    className: "".concat(blockName, "__content--left")
  }, React__default.createElement(Button$1, {
    onClick: onSaveToJunkClick,
    narrow: true,
    kind: "choice",
    disabled: saveToJunkDisabled
  }, "To Junk"), React__default.createElement(Button$1, {
    onClick: onSaveClick,
    narrow: true,
    disabled: saveDisabled
  }, "Save"), React__default.createElement(Chip, {
    className: "".concat(blockName, "__descriptuion"),
    onClick: onDescriptionClick,
    icon: isDescriptionOpen ? removeDescriptionIcon : addDescriptionIcon
  }, isDescriptionOpen ? 'Remove Description' : 'Add Description')), React__default.createElement("div", {
    className: "".concat(blockName, "__content--right")
  }, renderLinkTo && renderLinkTo()));
};

AgentChatWidgetFooter.propTypes = {
  className: PropTypes.string,
  onSaveClick: PropTypes.func,
  onSaveToJunkClick: PropTypes.func,
  onDescriptionClick: PropTypes.func,
  saveDisabled: PropTypes.bool,
  saveToJunkDisabled: PropTypes.bool,
  isDescriptionOpen: PropTypes.bool,
  renderLinkTo: PropTypes.func
};
AgentChatWidgetFooter.defaultProps = {
  className: '',
  saveDisabled: true,
  saveToJunkDisabled: true
};

var AgentChatWidget = function AgentChatWidget(_ref) {
  var className = _ref.className,
      customerName = _ref.customerName,
      customerInfo = _ref.customerInfo,
      onCustomerInfoItemClick = _ref.onCustomerInfoItemClick,
      isEnded = _ref.isEnded,
      isTyping = _ref.isTyping,
      status = _ref.status,
      isThreadVisible = _ref.isThreadVisible,
      showDescription = _ref.showDescription,
      showInput = _ref.showInput,
      data = _ref.data,
      onSendMessage = _ref.onSendMessage,
      jid = _ref.jid,
      inputPlaceholder = _ref.inputPlaceholder,
      inputValue = _ref.inputValue,
      descriptionValue = _ref.descriptionValue,
      onDescriptionChange = _ref.onDescriptionChange,
      onDescriptionSend = _ref.onDescriptionSend,
      onInputChange = _ref.onInputChange,
      onEndChatOptionClick = _ref.onEndChatOptionClick,
      isTransferEnabled = _ref.isTransferEnabled,
      transferOnly = _ref.transferOnly,
      onTransfer = _ref.onTransfer,
      onTransferCancel = _ref.onTransferCancel,
      isTransferError = _ref.isTransferError,
      transferIsDone = _ref.transferIsDone,
      transferErrorMessage = _ref.transferErrorMessage,
      searchTerm = _ref.searchTerm,
      onSearch = _ref.onSearch,
      agents = _ref.agents,
      maxHeight = _ref.maxHeight,
      onSaveClick = _ref.onSaveClick,
      onSaveToJunkClick = _ref.onSaveToJunkClick,
      saveDisabled = _ref.saveDisabled,
      saveToJunkDisabled = _ref.saveToJunkDisabled,
      renderLinkTo = _ref.renderLinkTo,
      links = _ref.links;
  var blockName = 'ch-agent-widget';

  var _useState = useState(isThreadVisible),
      _useState2 = _slicedToArray(_useState, 2),
      threadVisible = _useState2[0],
      setThreadVisible = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      descriptionVisible = _useState4[0],
      setDescriptionVisible = _useState4[1];

  var toggleDescription = function toggleDescription() {
    return setDescriptionVisible(!descriptionVisible);
  };

  var toggleThread = function toggleThread() {
    return setThreadVisible(!threadVisible);
  };

  useEffect(function () {
    setThreadVisible(isThreadVisible);
  }, [isThreadVisible]);
  useEffect(function () {
    setDescriptionVisible(showDescription);
  }, [showDescription]);
  var style = threadVisible && maxHeight ? {
    height: maxHeight,
    maxHeight: maxHeight
  } : {
    maxHeight: maxHeight
  };
  return React__default.createElement("div", {
    className: cx(blockName, _defineProperty({}, "".concat(blockName, "--with-open-thread"), threadVisible), className),
    style: style
  }, React__default.createElement(AgentChatWidgetHeader, {
    className: "".concat(blockName, "__header"),
    isEnded: isEnded,
    customerName: customerName,
    isTyping: isTyping,
    status: status,
    customerInfo: customerInfo,
    onCustomerInfoItemClick: onCustomerInfoItemClick,
    isTransferEnabled: isTransferEnabled,
    onTransfer: onTransfer,
    transferOnly: transferOnly,
    isTransferError: isTransferError,
    transferErrorMessage: transferErrorMessage,
    transferIsDone: transferIsDone,
    searchTerm: searchTerm,
    onSearch: onSearch,
    onTransferCancel: onTransferCancel,
    agents: agents,
    onEndChatOptionClick: onEndChatOptionClick
  }), threadVisible && React__default.createElement(ScrollContainer, {
    className: "".concat(blockName, "__scroll"),
    shouldScrollToBottom: true
  }, React__default.createElement(ChatThread, {
    className: "".concat(blockName, "__thread"),
    data: data,
    onSendMessage: onSendMessage,
    jid: jid
  })), React__default.createElement(AgentChatWidgetControls, {
    className: "".concat(blockName, "__controls"),
    isChatOpen: threadVisible,
    isEnded: isEnded,
    placeholder: inputPlaceholder,
    inputValue: inputValue,
    showInput: showInput,
    onInputChange: onInputChange,
    onSendMessage: onSendMessage,
    onToggleChatClick: toggleThread
  }), descriptionVisible && React__default.createElement("div", {
    className: "".concat(blockName, "__description")
  }, React__default.createElement(CustomerChatInput, {
    value: descriptionValue,
    onChange: onDescriptionChange,
    onSendMessage: onDescriptionSend,
    placeholder: "Describe the chat...",
    rows: 1,
    maxHeight: 100
  })), React__default.createElement(AgentChatWidgetFooter, {
    className: "".concat(blockName, "__footer"),
    onSaveClick: onSaveClick,
    onSaveToJunkClick: onSaveToJunkClick,
    onDescriptionClick: toggleDescription,
    saveDisabled: saveDisabled,
    saveToJunkDisabled: saveToJunkDisabled,
    isDescriptionOpen: descriptionVisible,
    renderLinkTo: renderLinkTo,
    links: links
  }));
};

AgentChatWidget.propTypes = _objectSpread2({}, omit(AgentChatInput.propTypes, ['value', 'className', 'onChange']), {}, omit(ChatThread.propTypes, ['className']), {
  className: PropTypes.string,
  inputClassName: AgentChatInput.propTypes.className,
  inputValue: AgentChatInput.propTypes.value,
  onInputChange: PropTypes.func,
  customerName: PropTypes.string,
  customerInfo: PropTypes.shape({
    contact: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string
    }),
    account: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string
    })
  }),
  onCustomerInfoItemClick: PropTypes.func,
  isEnded: PropTypes.bool,
  isTyping: PropTypes.bool,
  status: PropTypes.string,
  onTransfer: PropTypes.func,
  onTransferCancel: PropTypes.func,
  transferOnly: PropTypes.bool,
  isTransferEnabled: PropTypes.bool,
  isTransferError: PropTypes.bool,
  transferIsDone: PropTypes.bool,
  transferErrorMessage: PropTypes.string,
  onEndChatOptionClick: PropTypes.func.isRequired,
  renderSection: PropTypes.func,
  renderOption: PropTypes.func,
  agents: AgentChatTransfer.propTypes.agents,
  isThreadVisible: PropTypes.bool,
  showDescription: PropTypes.bool,
  maxHeight: PropTypes.number,
  onSaveClick: PropTypes.func,
  onSaveToJunkClick: PropTypes.func,
  saveDisabled: PropTypes.bool,
  saveToJunkDisabled: PropTypes.bool,
  renderLinkTo: PropTypes.func,
  links: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  showInput: PropTypes.bool
});
AgentChatWidget.defaultProps = {
  className: '',
  isThreadVisible: true,
  showDescription: false,
  customerName: 'Unknown Visitor',
  isTyping: false,
  isEnded: false,
  status: '',
  isTransferEnabled: true,
  maxHeight: 536,
  saveDisabled: true,
  saveToJunkDisabled: true,
  showInput: true
};

var addBreakIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNS43IDE1LjciPjxzdHlsZT4uY2gtYWRkLWJyZWFrLWljb25fc3ZnX19jaC1hZGQtYnJlYWstaWNvbl9zdmdfX2NoLWFkZC1pY29uX3N2Z19fc3Qxe2ZpbGw6IzAwNWZlY308L3N0eWxlPjxjaXJjbGUgY3g9IjcuOCIgY3k9IjcuOCIgcj0iNy4zIiBmaWxsPSIjZmZmIiBzdHJva2U9IiMwMDVmZWMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPjxwYXRoIGQ9Ik0xMC43IDcuM0g0LjljLS4zIDAtLjUuMi0uNS41cy4yLjUuNS41aDUuOGMuMyAwIC41LS4yLjUtLjVzLS4yLS41LS41LS41eiIgY2xhc3M9ImNoLWFkZC1icmVhay1pY29uX3N2Z19fY2gtYWRkLWJyZWFrLWljb25fc3ZnX19jaC1hZGQtaWNvbl9zdmdfX3N0MSIvPjxwYXRoIGQ9Ik03LjMgNC45djUuOGMwIC4zLjIuNS41LjVzLjUtLjIuNS0uNVY0LjljMC0uMy0uMi0uNS0uNS0uNXMtLjUuMy0uNS41eiIgY2xhc3M9ImNoLWFkZC1icmVhay1pY29uX3N2Z19fY2gtYWRkLWJyZWFrLWljb25fc3ZnX19jaC1hZGQtaWNvbl9zdmdfX3N0MSIvPjwvc3ZnPg==';

var Checkable =
/*#__PURE__*/
function (_Component) {
  _inherits(Checkable, _Component);

  function Checkable() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Checkable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Checkable)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          checked = _this$props.checked,
          disabled = _this$props.disabled,
          shouldPropagate = _this$props.shouldPropagate,
          onChange = _this$props.onChange;
      if (!shouldPropagate) event.stopPropagation();
      if (disabled) return;
      if (onChange) onChange(!checked, event);
    });

    return _this;
  }

  _createClass(Checkable, [{
    key: "render",
    value: function render() {
      var _cx;

      var _this$props2 = this.props,
          blockClassName = _this$props2.blockClassName,
          checkedClassName = _this$props2.checkedClassName,
          disabledClassName = _this$props2.disabledClassName,
          type = _this$props2.type,
          checked = _this$props2.checked,
          disabled = _this$props2.disabled,
          className = _this$props2.className,
          children = _this$props2.children;
      var finalClassName = cx(blockClassName, (_cx = {}, _defineProperty(_cx, checkedClassName, checked), _defineProperty(_cx, disabledClassName, disabled), _cx), className);
      var checkableControl = React__default.cloneElement(children, {
        onClick: this.handleClick
      });
      return React__default.createElement("div", {
        className: finalClassName,
        onKeyDown: keyboardClick(this.handleClick)
      }, React__default.createElement("input", {
        type: type,
        className: cx('ch-checkable__input', "".concat(className, "-input")),
        disabled: disabled,
        checked: checked,
        readOnly: true
      }), checkableControl);
    }
  }]);

  return Checkable;
}(Component);

_defineProperty(Checkable, "propTypes", {
  blockClassName: PropTypes.string,
  checkedClassName: PropTypes.string,
  disabledClassName: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.oneOf(['checkbox', 'radio']),
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  shouldPropagate: PropTypes.bool,
  onChange: PropTypes.func,
  children: PropTypes.node
});

_defineProperty(Checkable, "defaultProps", {
  type: 'checkbox',
  checked: false,
  disabled: false,
  shouldPropagate: false,
  onChange: noop,
  blockClassName: '',
  checkedClassName: '',
  disabledClassName: '',
  className: ''
});

var blockName$2 = 'ch-checkbox';

var Checkbox =
/*#__PURE__*/
function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).apply(this, arguments));
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          checked = _this$props.checked,
          disabled = _this$props.disabled,
          className = _this$props.className,
          other = _objectWithoutProperties(_this$props, ["size", "checked", "disabled", "className"]);

      var checkableProps = _objectSpread2({}, other, {
        type: 'checkbox',
        checked: checked,
        disabled: disabled,
        blockClassName: cx(blockName$2, className),
        checkedClassName: "".concat(blockName$2, "--active"),
        disabledClassName: "".concat(blockName$2, "--disabled")
      });

      return React__default.createElement(Checkable, checkableProps, React__default.createElement("div", {
        className: "".concat(blockName$2, "__image-wrapper"),
        role: "checkbox",
        "aria-checked": checked,
        tabIndex: disabled ? -1 : 0
      }, React__default.createElement("svg", {
        viewBox: "0 0 20 20",
        height: size,
        width: size
      }, React__default.createElement("g", {
        className: "".concat(blockName$2, "__box")
      }, React__default.createElement("rect", {
        width: "20",
        height: "20",
        rx: 3,
        stroke: "none"
      }), React__default.createElement("rect", {
        x: ".5",
        y: ".5",
        width: "19",
        height: "19",
        rx: 3,
        fill: "none"
      })), React__default.createElement("path", {
        className: "".concat(blockName$2, "__checkmark"),
        fill: "none",
        strokeWidth: "1.3",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: "10",
        d: "M4.3 10.8l3.6 3.8 7.8-7.8",
        strokeDasharray: "17px",
        strokeDashoffset: "17px"
      }))));
    }
  }]);

  return Checkbox;
}(Component);

_defineProperty(Checkbox, "propTypes", {
  className: PropTypes.string,
  size: PropTypes.number,
  checked: PropTypes.bool,
  disabled: PropTypes.bool
});

_defineProperty(Checkbox, "defaultProps", {
  className: '',
  size: 16
});

var blockName$3 = 'ch-editable-field';

var defaultValueRenderer = function defaultValueRenderer(value) {
  return value;
};

var withEditableField = function withEditableField(WrappedComponent) {
  var WithEditableField =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(WithEditableField, _React$Component);

    function WithEditableField() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, WithEditableField);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WithEditableField)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "focusTimeout", null);

      _defineProperty(_assertThisInitialized(_this), "inputRef", null);

      _defineProperty(_assertThisInitialized(_this), "state", {
        focused: false
      });

      _defineProperty(_assertThisInitialized(_this), "updateFocused", function (value) {
        return _this.setState({
          focused: value
        });
      });

      _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
        var _this$props = _this.props,
            disabled = _this$props.disabled,
            dirty = _this$props.dirty,
            onBlur = _this$props.onBlur;
        if (disabled || dirty) return;

        _this.updateFocused(false);

        if (onBlur) {
          onBlur(event);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "handleFocus", function (event) {
        var _this$props2 = _this.props,
            disabled = _this$props2.disabled,
            readOnly = _this$props2.readOnly,
            onFocus = _this$props2.onFocus;
        if (disabled || readOnly) return;

        _this.updateFocused(true);

        _this.focusInput();

        if (onFocus) {
          onFocus(event);
        }
      });

      _defineProperty(_assertThisInitialized(_this), "focusInput", function () {
        _this.focusTimeout = setTimeout(function () {
          if (_this.inputRef !== null) {
            _this.inputRef.focus();
          }
        }, 0);
      });

      return _this;
    }

    _createClass(WithEditableField, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.autoFocus) {
          this.updateFocused(true);
          this.focusInput();
        }
      } // eslint-disable-next-line

    }, {
      key: "UNSAFE_componentWillReceiveProps",
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.disabled && this.state.focused) {
          this.updateFocused(false);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.focusTimeout !== null) {
          clearTimeout(this.focusTimeout);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _cx,
            _this2 = this;

        var _this$props3 = this.props,
            value = _this$props3.value,
            type = _this$props3.type,
            disabled = _this$props3.disabled,
            className = _this$props3.className,
            componentClassName = _this$props3.componentClassName,
            valueRenderer = _this$props3.valueRenderer;
        var focused = this.state.focused;
        var wrapperClassName = cx(className, blockName$3, (_cx = {}, _defineProperty(_cx, "".concat(blockName$3, "--focused"), focused), _defineProperty(_cx, "".concat(blockName$3, "--disabled"), disabled), _defineProperty(_cx, "".concat(blockName$3, "--type-").concat(type), type), _cx));
        return React__default.createElement("div", {
          className: wrapperClassName,
          tabIndex: 0,
          onClick: this.handleFocus,
          role: "textbox",
          onKeyDown: keyboardClick(this.handleFocus),
          onFocus: this.handleFocus
        }, React__default.createElement("div", {
          className: cx("".concat(blockName$3, "__value"), _defineProperty({}, "".concat(blockName$3, "--type-").concat(type), type))
        }, valueRenderer(value, this.props)), React__default.createElement("div", {
          className: "".concat(blockName$3, "__edit")
        }, React__default.createElement(WrappedComponent, _extends({}, omit(this.props, ['valueRenderer']), {
          className: componentClassName,
          focused: this.state.focused,
          onBlur: this.handleBlur,
          inputRef: function inputRef(ref) {
            _this2.inputRef = ref;
          }
        }))));
      }
    }]);

    return WithEditableField;
  }(React__default.Component);

  _defineProperty(WithEditableField, "propTypes", _objectSpread2({}, WrappedComponent.propTypes, {
    componentClassName: PropTypes.string,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    valueRenderer: PropTypes.func
  }));

  _defineProperty(WithEditableField, "defaultProps", _objectSpread2({}, WrappedComponent.defaultProps, {
    componentClassName: '',
    onFocus: noop,
    onBlur: noop,
    valueRenderer: defaultValueRenderer
  }));

  return WithEditableField;
};

var TEXT_FIELD_TYPES$1 = {
  TEXT: 'text',
  NUMBER: 'number',
  TEXTAREA: 'textarea',
  CURRENCY: 'currency',
  EMAIL: 'email',
  URL: 'url'
};
var inputRefPropType$1 = PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
  current: PropTypes.instanceOf( // eslint-disable-next-line func-names
  typeof Element === 'undefined' ? function () {} : Element)
})]);
var blockName$4 = 'ch-timetextfield';

var TextField$2 =
/*#__PURE__*/
function (_Component) {
  _inherits(TextField, _Component);

  function TextField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TextField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TextField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      _this.props.onChange(event, event.target.value);
    });

    return _this;
  }

  _createClass(TextField, [{
    key: "renderInput",
    value: function renderInput(inputProps) {
      var type = inputProps.type,
          classes = inputProps.classes,
          inputClassName = inputProps.inputClassName,
          inputId = inputProps.inputId,
          inputRef = inputProps.inputRef,
          suffixProps = inputProps.suffixProps,
          componentClassName = inputProps.componentClassName,
          other = _objectWithoutProperties(inputProps, ["type", "classes", "inputClassName", "inputId", "inputRef", "suffixProps", "componentClassName"]);

      var componentType = type === TEXT_FIELD_TYPES$1.TEXTAREA ? type : 'input';
      var finalInputClassName = cx(inputClassName, "".concat(blockName$4, "__input"), _defineProperty({}, "".concat(blockName$4, "__input--type-").concat(componentType), componentType && "".concat(blockName$4, "__input--type-").concat(componentType)));
      return createElement(componentType, _objectSpread2({}, other, {
        type: type === TEXT_FIELD_TYPES$1.TEXTAREA ? undefined : type,
        id: inputId,
        ref: inputRef,
        onChange: this.handleChange,
        className: finalInputClassName
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _cx2;

      var _this$props = this.props,
          isError = _this$props.isError,
          focused = _this$props.focused,
          disabled = _this$props.disabled,
          className = _this$props.className,
          readOnly = _this$props.readOnly,
          type = _this$props.type,
          noBorder = _this$props.noBorder,
          errorMessage = _this$props.errorMessage,
          other = _objectWithoutProperties(_this$props, ["isError", "focused", "disabled", "className", "readOnly", "type", "noBorder", "errorMessage"]);

      var finalClassName = cx(className, blockName$4, (_cx2 = {}, _defineProperty(_cx2, "".concat(blockName$4, "--error"), isError), _defineProperty(_cx2, "".concat(blockName$4, "--active"), focused), _defineProperty(_cx2, "".concat(blockName$4, "--no-border"), noBorder), _defineProperty(_cx2, "".concat(blockName$4, "--disabled"), disabled), _defineProperty(_cx2, "".concat(blockName$4, "--disabled-error"), isError && disabled), _defineProperty(_cx2, "".concat(blockName$4, "--active-error"), isError && focused), _defineProperty(_cx2, "".concat(blockName$4, "--type-").concat(type), type), _cx2));

      var inputProps = _objectSpread2({}, other, {
        type: type,
        disabled: disabled,
        readOnly: readOnly
      });

      var showErrorMessage = isError && errorMessage;
      return React__default.createElement("div", {
        className: finalClassName
      }, this.renderInput(inputProps), showErrorMessage && React__default.createElement("p", {
        className: "".concat(blockName$4, "__error-message")
      }, errorMessage));
    }
  }]);

  return TextField;
}(Component);

_defineProperty(TextField$2, "propTypes", {
  /** `type` property of `<input>` tag. */
  type: PropTypes.string,
  onCut: PropTypes.func,
  value: PropTypes.string,
  onBlur: PropTypes.func,
  onCopy: PropTypes.func,
  onPaste: PropTypes.func,

  /** `id` of native `<input>`. */
  inputId: PropTypes.string,
  inputRef: inputRefPropType$1,
  onFocus: PropTypes.func,
  isError: PropTypes.bool,
  focused: PropTypes.bool,
  readOnly: PropTypes.bool,
  noBorder: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  placeholder: PropTypes.string,
  errorMessage: PropTypes.string
});

_defineProperty(TextField$2, "defaultProps", {
  type: 'text',
  value: '',
  onCut: noop,
  onBlur: noop,
  onCopy: noop,
  onPaste: noop,
  inputRef: noop,
  isError: false,
  focused: false,
  noBorder: true,
  onFocus: noop,
  disabled: false,
  onChange: noop,
  autoFocus: false,
  readOnly: false,
  errorMessage: ''
});

var TimeTextField = withFocusedState(withEditableField(TextField$2));

var blockName$5 = 'ch-range-field';

var RangeField =
/*#__PURE__*/
function (_Component) {
  _inherits(RangeField, _Component);

  function RangeField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RangeField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RangeField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "renderHandle", function (handleProps) {
      var values = _this.props.values;
      var index = handleProps.index;
      var extraProps = omit(handleProps, ['dragging']);

      if (index !== 0 && index < values.length - 1) {
        return React__default.createElement(Handle, _extends({
          key: index
        }, extraProps, {
          style: {
            display: 'none'
          }
        }));
      }

      return React__default.createElement(Handle, _extends({
        key: index
      }, extraProps));
    });

    return _this;
  }

  _createClass(RangeField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          min = _this$props.min,
          max = _this$props.max,
          step = _this$props.step,
          className = _this$props.className,
          values = _this$props.values,
          onAfterChange = _this$props.onAfterChange,
          onChange = _this$props.onChange,
          colors = _this$props.colors,
          readOnly = _this$props.readOnly,
          other = _objectWithoutProperties(_this$props, ["min", "max", "step", "className", "values", "onAfterChange", "onChange", "colors", "readOnly"]);

      var finalClass = cx(blockName$5, className);
      var trackStyle = colors.map(function (color) {
        return {
          backgroundColor: color
        };
      });
      return React__default.createElement("div", {
        className: finalClass
      }, React__default.createElement(Range, _extends({}, other, {
        disabled: readOnly,
        min: min,
        max: max,
        step: step,
        value: values,
        handle: this.renderHandle,
        trackStyle: trackStyle,
        onAfterChange: onAfterChange,
        onChange: onChange
      })));
    }
  }]);

  return RangeField;
}(Component);

_defineProperty(RangeField, "displayName", 'RangeField');

_defineProperty(RangeField, "propTypes", {
  className: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  onChange: PropTypes.func,
  onAfterChange: PropTypes.func,
  colors: PropTypes.arrayOf(PropTypes.string),
  readOnly: PropTypes.bool
});

_defineProperty(RangeField, "defaultProps", {
  values: [],
  colors: ['#005FEC'],
  min: 0,
  max: 1439,
  step: 1,
  onChange: noop,
  onAfterChange: noop,
  readOnly: false
});

var blockName$6 = 'ch-bh-picker';

var BusinessHoursPicker =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(BusinessHoursPicker, _PureComponent);

  function BusinessHoursPicker() {
    _classCallCheck(this, BusinessHoursPicker);

    return _possibleConstructorReturn(this, _getPrototypeOf(BusinessHoursPicker).apply(this, arguments));
  }

  _createClass(BusinessHoursPicker, [{
    key: "render",
    value: function render() {
      var _cx;

      var _this$props = this.props,
          className = _this$props.className,
          startTime = _this$props.startTime,
          endTime = _this$props.endTime,
          rangeValues = _this$props.rangeValues,
          rangeColors = _this$props.rangeColors,
          onButtonClick = _this$props.onButtonClick,
          onCheckboxClick = _this$props.onCheckboxClick,
          onStartTimeChange = _this$props.onStartTimeChange,
          onEndTimeChange = _this$props.onEndTimeChange,
          onRangeFieldChange = _this$props.onRangeFieldChange,
          label = _this$props.label,
          isBreak = _this$props.isBreak,
          isClosed = _this$props.isClosed;
      var wrapperClassName = cx(blockName$6, className, (_cx = {}, _defineProperty(_cx, "".concat(blockName$6, "--break"), isBreak), _defineProperty(_cx, "".concat(blockName$6, "--closed"), isClosed), _cx));
      return React__default.createElement("tr", {
        className: wrapperClassName
      }, React__default.createElement("td", {
        className: "".concat(blockName$6, "__checkbox")
      }, !isBreak && React__default.createElement(Checkbox, {
        onClick: onCheckboxClick,
        checked: !isClosed
      })), React__default.createElement("td", {
        className: "".concat(blockName$6, "__label")
      }, label), React__default.createElement("td", {
        className: "".concat(blockName$6, "__start-time")
      }, React__default.createElement(TimeTextField, {
        value: startTime,
        onChange: onStartTimeChange,
        disabled: isClosed
      })), React__default.createElement("td", {
        className: "".concat(blockName$6, "__range-field")
      }, React__default.createElement(RangeField, {
        values: rangeValues,
        onChange: onRangeFieldChange,
        colors: rangeColors
      })), React__default.createElement("td", {
        className: "".concat(blockName$6, "__end-time")
      }, React__default.createElement(TimeTextField, {
        value: endTime,
        onChange: onEndTimeChange,
        disabled: isClosed
      })), React__default.createElement("td", {
        className: "".concat(blockName$6, "__break-controls")
      }, !isClosed && React__default.createElement("div", {
        className: "".concat(blockName$6, "__break-button"),
        onClick: onButtonClick,
        onKeyDown: keyboardClick(onButtonClick)
      }, isBreak ? 'remove' : React__default.createElement(Svg, {
        src: addBreakIcon,
        width: 16,
        height: 16
      }))));
    }
  }]);

  return BusinessHoursPicker;
}(PureComponent);

BusinessHoursPicker.propTypes = {
  startTime: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
  onStartTimeChange: PropTypes.func.isRequired,
  onEndTimeChange: PropTypes.func.isRequired,
  onRangeFieldChange: PropTypes.func.isRequired,
  rangeValues: PropTypes.arrayOf(PropTypes.number).isRequired,
  onButtonClick: PropTypes.func.isRequired,
  rangeColors: PropTypes.arrayOf(PropTypes.string).isRequired,
  onCheckboxClick: PropTypes.func,
  className: PropTypes.string,
  label: PropTypes.string,
  isBreak: PropTypes.bool,
  isClosed: PropTypes.bool
};
BusinessHoursPicker.defaultProps = {
  className: '',
  label: '',
  onCheckboxClick: noop,
  isBreak: false,
  isClosed: false
};

var Card =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Card, _React$PureComponent);

  function Card() {
    _classCallCheck(this, Card);

    return _possibleConstructorReturn(this, _getPrototypeOf(Card).apply(this, arguments));
  }

  _createClass(Card, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          description = _this$props.description,
          callToAction = _this$props.callToAction,
          isHorizontal = _this$props.isHorizontal,
          onClick = _this$props.onClick,
          svg = _this$props.svg;
      return React__default.createElement("div", {
        className: cx('Card', {
          'Card--horizontal': isHorizontal
        }),
        onClick: onClick,
        onKeyDown: keyboardClick(onClick)
      }, React__default.createElement("div", {
        className: "Card--image-container"
      }, React__default.createElement(Svg, {
        src: svg
      })), React__default.createElement("div", {
        className: "Card--title"
      }, title), React__default.createElement("div", {
        className: "Card--description"
      }, description), callToAction && React__default.createElement("div", {
        className: "Card--call-to-action"
      }, callToAction));
    }
  }]);

  return Card;
}(React__default.PureComponent);

Card.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  callToAction: PropTypes.string,
  isHorizontal: PropTypes.bool,
  onClick: PropTypes.func,
  svg: PropTypes.string
};
Card.defaultProps = {
  title: '',
  description: '',
  callToAction: '',
  isHorizontal: false,
  onClick: function onClick() {},
  svg: ''
};

var defaultIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyMy43NjIiIHZpZXdCb3g9IjAgMCAyNCAyMy43NjIiPjxwYXRoIGQ9Ik0yNCAyMy43NjJsLTYuMDYzLTIuNTQyYTExLjU2NiAxMS41NjYgMCAxMTMuOTMzLTQuNHpNMTEuNTUxIDEuNjY5YTkuODkyIDkuODkyIDAgMTA1Ljc5IDE3LjkxM2wuMzgyLS4yODEgMy42MDcgMS41MTEtMS4yODEtNC4xNzIuMTcxLS4zYTkuODk1IDkuODk1IDAgMDAtOC42Ny0xNC42Njh6IiBmaWxsPSIjZmZmIi8+PC9zdmc+';

var ChatButton = function ChatButton(props) {
  var _cx;

  var blockName = 'ch-chat-button';
  var icon = props.icon,
      text = props.text,
      onClick = props.onClick,
      borderOnly = props.borderOnly,
      backgroundColor = props.backgroundColor,
      contentColor = props.contentColor,
      disabled = props.disabled;
  var bgColor = borderOnly ? '#fff' : backgroundColor;

  var handleClick = function handleClick(event) {
    if (disabled) return;
    onClick(event);
  };

  return React__default.createElement("div", {
    className: cx(blockName, (_cx = {}, _defineProperty(_cx, "".concat(blockName, "--with-border"), borderOnly), _defineProperty(_cx, "".concat(blockName, "--disabled"), disabled), _cx)),
    style: {
      borderColor: backgroundColor,
      backgroundColor: bgColor
    },
    onClick: handleClick,
    onKeyDown: keyboardClick(handleClick)
  }, React__default.createElement(Svg, {
    className: "".concat(blockName, "__icon"),
    src: icon,
    width: "34px",
    height: "34px",
    color: contentColor
  }), text && React__default.createElement("span", {
    className: "".concat(blockName, "__text"),
    style: {
      color: contentColor
    }
  }, text));
};

ChatButton.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string,
  icon: PropTypes.string,
  backgroundColor: PropTypes.string,
  contentColor: PropTypes.string,
  borderOnly: PropTypes.bool,
  disabled: PropTypes.bool
};
ChatButton.defaultProps = {
  onClick: noop,
  text: '',
  icon: defaultIcon,
  backgroundColor: '#005FEC',
  contentColor: '#fff',
  borderOnly: false,
  disabled: false
};

var ChatEndConfirmation = function ChatEndConfirmation(_ref) {
  var className = _ref.className,
      onCancel = _ref.onCancel,
      onConfirm = _ref.onConfirm,
      title = _ref.title;
  var blockName = 'ch-chat-end-confirmation';
  return React__default.createElement("div", {
    className: cx("".concat(blockName), className)
  }, React__default.createElement("div", {
    className: "".concat(blockName, "__title")
  }, title), React__default.createElement("div", {
    className: "".concat(blockName, "__button-container")
  }, React__default.createElement(Button$1, {
    className: "".concat(blockName, "__button"),
    kind: "cancel",
    onClick: onCancel
  }, "Cancel"), React__default.createElement(Button$1, {
    className: "".concat(blockName, "__button"),
    kind: "default",
    onClick: onConfirm
  }, "End Chat")));
};

ChatEndConfirmation.propTypes = {
  className: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  title: PropTypes.func
};
ChatEndConfirmation.defaultProps = {
  className: '',
  onCancel: noop,
  onConfirm: noop,
  title: 'End Chat'
};

var ChatPopMessages = function ChatPopMessages(_ref) {
  var className = _ref.className,
      messages = _ref.messages,
      onScroll = _ref.onScroll;
  return React__default.createElement("div", {
    className: cx('chat-pop-messages', className)
  }, React__default.createElement("div", {
    className: "chat-pop-messages__label"
  }, "Messages"), React__default.createElement(ScrollContainer, {
    className: "chat-pop-messages__container",
    onScroll: onScroll
  }, messages.map(function (m) {
    var message = m.message,
        id = m.id;
    var messageClassName = cx('chat-pop-message', {
      'chat-pop-message--single': messages.length === 1
    });
    return React__default.createElement("div", {
      className: messageClassName,
      key: id
    }, React__default.createElement("span", {
      className: "chat-pop-message__text"
    }, React__default.createElement(WithNewLines, null, message)));
  })));
};

ChatPopMessages.propTypes = {
  className: PropTypes.string,
  messages: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
  onScroll: PropTypes.func
};
ChatPopMessages.defaultProps = {
  className: '',
  messages: [],
  onScroll: noop
};

var ChatPopControls =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ChatPopControls, _PureComponent);

  function ChatPopControls() {
    _classCallCheck(this, ChatPopControls);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChatPopControls).apply(this, arguments));
  }

  _createClass(ChatPopControls, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          isLoading = _this$props.isLoading,
          onDismiss = _this$props.onDismiss,
          onAccept = _this$props.onAccept;
      var baseClassName = 'chat-pop-controls';
      var buttonClassName = "".concat(baseClassName, "__button");
      var wrapperClassName = cx(baseClassName, _defineProperty({}, "".concat(baseClassName, "--active"), !isLoading), className);
      return React__default.createElement("div", {
        className: wrapperClassName
      }, React__default.createElement("button", {
        className: cx(buttonClassName, "".concat(buttonClassName, "--dismiss")),
        type: "button",
        disabled: isLoading,
        onClick: onDismiss
      }, "Dismiss"), React__default.createElement("button", {
        className: cx(buttonClassName, "".concat(buttonClassName, "--accept")),
        type: "button",
        disabled: isLoading,
        onClick: onAccept
      }, "Accept"));
    }
  }]);

  return ChatPopControls;
}(PureComponent);

ChatPopControls.propTypes = {
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  onDismiss: PropTypes.func,
  onAccept: PropTypes.func
};
ChatPopControls.defaultProps = {
  className: '',
  isLoading: false,
  onDismiss: noop,
  onAccept: noop
};

var blockName$7 = 'Countdown';

var Countdown =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Countdown, _React$PureComponent);

  function Countdown() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Countdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Countdown)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      done: false,
      value: _this.props.countFrom || _this.props.value
    });

    _defineProperty(_assertThisInitialized(_this), "counter", null);

    _defineProperty(_assertThisInitialized(_this), "startCountdown", function () {
      var onFinish = _this.props.onFinish;
      var done = _this.state.done;
      if (_this.counter !== null) clearInterval(_this.counter);
      if (done) _this.setState({
        done: false
      });
      _this.counter = setInterval(function () {
        var value = _this.state.value;

        if (value > 1) {
          _this.setState({
            value: value - 1
          });
        } else {
          _this.setState({
            done: true
          });

          clearInterval(_this.counter);
          onFinish();
        }
      }, 1000);
    });

    return _this;
  }

  _createClass(Countdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startCountdown();
    } // eslint-disable-next-line

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var stateValue = this.state.value;
      var value = nextProps.value;

      if (value !== stateValue) {
        this.setState({
          value: value
        });
        this.startCountdown();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.counter !== null) {
        clearInterval(this.counter);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _cx;

      var _this$props = this.props,
          className = _this$props.className,
          countFrom = _this$props.countFrom;
      var _this$state = this.state,
          value = _this$state.value,
          done = _this$state.done;
      var finalClassName = cx(blockName$7, className, (_cx = {}, _defineProperty(_cx, "".concat(blockName$7, "--yellow"), value <= Math.ceil(countFrom / 1.5)), _defineProperty(_cx, "".concat(blockName$7, "--red"), value <= Math.ceil(countFrom / 2.5)), _defineProperty(_cx, "".concat(blockName$7, "--done"), done), _cx));
      return React__default.createElement("div", {
        className: finalClassName
      }, value);
    }
  }]);

  return Countdown;
}(React__default.PureComponent);

_defineProperty(Countdown, "propTypes", {
  className: PropTypes.string,
  countFrom: PropTypes.number,
  value: PropTypes.number,
  onFinish: PropTypes.func
});

_defineProperty(Countdown, "defaultProps", {
  className: '',
  countFrom: 10,
  value: 10,
  onFinish: noop
});

var iconStar = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBmaWxsPSIjRUJDMzU0IiBkPSJNOCAuNmwyLjUgNC44NTggNS41Ljc3OC00IDMuNzg5LjkgNS4zNDRMOCAxMi44NDNsLTQuOSAyLjUyNi45LTUuMzQ0LTQtMy43ODkgNS41LS43Nzh6Ii8+PC9zdmc+';

var blockName$8 = 'Rating';
var itemName = "".concat(blockName$8, "__item");
var amount = 5;

var Rating =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Rating, _PureComponent);

  function Rating() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Rating);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Rating)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      focused: false
    });

    _defineProperty(_assertThisInitialized(_this), "computeValue", function () {
      var _this$props = _this.props,
          maxValue = _this$props.maxValue,
          value = _this$props.value;
      return Math.ceil(value / maxValue * amount);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e, rating) {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          readOnly = _this$props2.readOnly;

      if (onChange && !readOnly) {
        onChange(e, rating);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e, index) {
      var readOnly = _this.props.readOnly;

      if (!readOnly) {
        _this.setState({
          focused: index
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      var readOnly = _this.props.readOnly;

      if (!readOnly) {
        _this.setState({
          focused: false
        });
      }
    });

    return _this;
  }

  _createClass(Rating, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          className = _this$props3.className,
          readOnly = _this$props3.readOnly;
      var focused = this.state.focused;
      var value = this.computeValue();
      return React__default.createElement("div", {
        className: cx(blockName$8, className, _defineProperty({}, "".concat(blockName$8, "--hoverable"), !readOnly))
      }, Array.from({
        length: amount
      }, function (_, i) {
        return i;
      }).map(function (i) {
        var _cx2;

        var itemIndex = amount - i;
        var compare = focused || value;
        var itemClassName = cx(itemName, (_cx2 = {}, _defineProperty(_cx2, "".concat(itemName, "--active"), itemIndex <= compare), _defineProperty(_cx2, "".concat(itemName, "--changeable"), !readOnly), _cx2));

        var handleItemClick = function handleItemClick(e) {
          return _this2.handleClick(e, itemIndex);
        };

        var handleItemFocus = function handleItemFocus(e) {
          return _this2.handleFocus(e, itemIndex);
        };

        return React__default.createElement("div", {
          className: itemClassName,
          key: i,
          role: "button",
          tabIndex: 0,
          onClick: handleItemClick,
          onKeyDown: keyboardClick(handleItemClick),
          onFocus: handleItemFocus,
          onBlur: _this2.handleBlur
        }, React__default.createElement(Svg, {
          src: iconStar
        }));
      }));
    }
  }]);

  return Rating;
}(PureComponent);

_defineProperty(Rating, "propTypes", {
  className: PropTypes.string,
  readOnly: PropTypes.bool,
  value: PropTypes.number,
  maxValue: PropTypes.number,
  onChange: PropTypes.func
});

_defineProperty(Rating, "defaultProps", {
  className: '',
  readOnly: false,
  maxValue: 5,
  value: null,
  onChange: function onChange() {}
});

var ChatPopInQueue =
/*#__PURE__*/
function (_Component) {
  _inherits(ChatPopInQueue, _Component);

  function ChatPopInQueue() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ChatPopInQueue);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ChatPopInQueue)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "tick", function () {
      _this.setState({
        callTime: _this.getCallTime()
      });
    });

    return _this;
  }

  _createClass(ChatPopInQueue, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.timer = setInterval(this.tick, 1000);
      this.setState({
        callTime: this.getCallTime()
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.timer);
    }
  }, {
    key: "getCallTime",
    value: function getCallTime() {
      var chatStartTime = this.props.chatStartTime;
      var chatTime = new Date() - new Date(chatStartTime);
      return "".concat(getMinutes(chatTime), " min ").concat(getSeconds(chatTime), " sec");
    }
  }, {
    key: "render",
    value: function render() {
      return React__default.createElement("span", {
        className: "ch-chat-pop__in-queue"
      }, "In queue for: ", this.state.callTime);
    }
  }]);

  return ChatPopInQueue;
}(Component);

_defineProperty(ChatPopInQueue, "propTypes", {
  chatStartTime: PropTypes.string
});

_defineProperty(ChatPopInQueue, "defaultProps", {
  chatStartTime: getUtcIsoTimestamp()
});

var baseClassName = 'ch-chat-pop';

var ChatPop =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ChatPop, _PureComponent);

  function ChatPop() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ChatPop);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ChatPop)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "renderTeamAndRating", function () {
      var _this$props = _this.props,
          team = _this$props.team,
          ratingValue = _this$props.ratingValue,
          ratignMaxValue = _this$props.ratignMaxValue;
      var className = "".concat(baseClassName, "__team-and-rating");
      if (team === '' && ratingValue === null) return null;
      var rating = React__default.createElement(Rating, {
        value: ratingValue,
        maxValue: ratignMaxValue,
        readOnly: true
      });
      return React__default.createElement("div", {
        className: className
      }, team && React__default.createElement(ExtraInfo, {
        className: "".concat(className, "__team"),
        label: "Team",
        value: team
      }), ratingValue && React__default.createElement(ExtraInfo, {
        className: "".concat(className, "__rating"),
        label: "last survey response",
        value: rating
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderExtraInfo", function () {
      var extraInfo = _this.props.extraInfo;
      if (extraInfo.length === 0) return null;
      return React__default.createElement("div", null, extraInfo.map(function (_ref) {
        var label = _ref.label,
            value = _ref.value,
            href = _ref.href;
        return React__default.createElement(ExtraInfo, {
          key: label,
          label: label,
          value: value,
          href: href
        });
      }));
    });

    return _this;
  }

  _createClass(ChatPop, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          kind = _this$props2.kind,
          onDismiss = _this$props2.onDismiss,
          onAccept = _this$props2.onAccept,
          onTimeout = _this$props2.onTimeout,
          name = _this$props2.name,
          company = _this$props2.company,
          messages = _this$props2.messages,
          countFrom = _this$props2.countFrom,
          countValue = _this$props2.countValue,
          chatStartTime = _this$props2.chatStartTime;
      var wrapperClassName = cx(baseClassName, className);
      return React__default.createElement("div", {
        className: wrapperClassName
      }, React__default.createElement("div", {
        className: "".concat(baseClassName, "__header")
      }, React__default.createElement("span", {
        className: "".concat(baseClassName, "__kind")
      }, kind === 'user' ? 'user initiated chat' : 'proactive chat'), React__default.createElement(ChatPopInQueue, {
        chatStartTime: chatStartTime
      })), React__default.createElement("div", {
        className: "".concat(baseClassName, "__main")
      }, React__default.createElement("div", {
        className: "".concat(baseClassName, "__subheader")
      }, React__default.createElement("div", {
        className: "".concat(baseClassName, "__name-and-counter")
      }, React__default.createElement("span", {
        className: "".concat(baseClassName, "__name")
      }, name), React__default.createElement("span", {
        className: "".concat(baseClassName, "__counter")
      }, React__default.createElement(Countdown, {
        countFrom: countFrom,
        value: countValue,
        onFinish: onTimeout
      }))), company && React__default.createElement("div", {
        className: "".concat(baseClassName, "__company")
      }, company)), this.renderTeamAndRating(), this.renderExtraInfo(), messages.length !== 0 && React__default.createElement(ChatPopMessages, {
        messages: messages
      }), React__default.createElement(ChatPopControls, {
        onDismiss: onDismiss,
        onAccept: onAccept
      })));
    }
  }]);

  return ChatPop;
}(PureComponent);

_defineProperty(ChatPop, "propTypes", {
  className: PropTypes.string,
  kind: PropTypes.oneOf(['user', 'proactive']),
  onDismiss: PropTypes.func,
  onAccept: PropTypes.func,
  onTimeout: PropTypes.func,
  name: PropTypes.string,
  company: PropTypes.string,
  team: PropTypes.string,
  extraInfo: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
  ratingValue: PropTypes.number,
  ratignMaxValue: PropTypes.number,
  messages: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
  countFrom: PropTypes.number,
  countValue: PropTypes.number,
  chatStartTime: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
});

_defineProperty(ChatPop, "defaultProps", {
  className: '',
  kind: 'user',
  onDismiss: noop,
  onAccept: noop,
  onTimeout: noop,
  name: 'Unknown Visitor',
  company: '',
  team: '',
  extraInfo: [],
  messages: [],
  ratingValue: null,
  ratignMaxValue: null,
  countFrom: 10,
  countValue: 10,
  chatStartTime: getUtcIsoTimestamp()
});

var CustomerHeader =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CustomerHeader, _React$PureComponent);

  function CustomerHeader() {
    _classCallCheck(this, CustomerHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(CustomerHeader).apply(this, arguments));
  }

  _createClass(CustomerHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          online = _this$props.online,
          header = _this$props.header,
          closeHandler = _this$props.closeHandler;
      var className = 'CustomerHeader';
      return React__default.createElement("div", {
        className: cx(className, _defineProperty({}, "".concat(className, "--online"), online))
      }, React__default.createElement("span", {
        className: "".concat(className, "-title")
      }, header), React__default.createElement("span", {
        className: "".concat(className, "-close"),
        onClick: closeHandler,
        onKeyDown: keyboardClick(closeHandler)
      }, React__default.createElement(Svg, {
        width: 10,
        height: 10,
        src: closeIcon
      })));
    }
  }]);

  return CustomerHeader;
}(React__default.PureComponent);

CustomerHeader.propTypes = {
  online: PropTypes.bool,
  closeHandler: PropTypes.func,
  header: PropTypes.string
};
CustomerHeader.defaultProps = {
  header: 'Send us an email',
  online: false,
  closeHandler: function closeHandler() {}
};

var ChatWindow =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ChatWindow, _React$PureComponent);

  function ChatWindow(props, context) {
    var _this;

    _classCallCheck(this, ChatWindow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ChatWindow).call(this, props, context));

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      return _this.setState({
        modal: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      return _this.setState({
        modal: false
      });
    });

    _this.state = {
      modal: false
    };
    return _this;
  }

  _createClass(ChatWindow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          online = _this$props.online,
          style = _this$props.style,
          children = _this$props.children,
          renderLogo = _this$props.renderLogo,
          renderHeaderText = _this$props.renderHeaderText;
      var passedStyle = online ? style.window.online : style.window.offline;
      return React__default.createElement("div", {
        className: "realtalkcustomer open",
        style: passedStyle
      }, React__default.createElement("div", {
        className: "open rtc-max"
      }, React__default.createElement(CustomerHeader, {
        online: online,
        style: style.header,
        renderLogo: renderLogo,
        renderHeaderText: renderHeaderText
      }), children));
    }
  }]);

  return ChatWindow;
}(React__default.PureComponent);

ChatWindow.propTypes = {
  online: PropTypes.bool.isRequired,
  style: PropTypes.objectOf(PropTypes.string),
  children: PropTypes.func,
  renderLogo: PropTypes.func,
  renderHeaderText: PropTypes.func
};
ChatWindow.defaultProps = {
  style: {
    online: {},
    offline: {}
  }
};

var Chooser =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Chooser, _React$Component);

  function Chooser() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Chooser);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Chooser)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      current: 0
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (current) {
      var onChange = _this.props.onChange;

      _this.setState({
        current: current
      });

      onChange(current);
    });

    return _this;
  }

  _createClass(Chooser, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          onChange = _this$props.onChange,
          text = _this$props.text,
          title = _this$props.title;
      var current = this.state.current;
      return React__default.createElement("div", {
        className: "Chooser"
      }, React__default.createElement("span", {
        className: "Chooser--title"
      }, title), React__default.createElement("div", {
        className: "Chooser-content"
      }, data.map(function (renderProp, idx) {
        return React__default.createElement("div", {
          className: "Chooser--container",
          onClick: function onClick() {
            return _this2.handleClick(idx);
          },
          onKeyDown: function onKeyDown(e) {
            return keyboardClick(e)(_this2.handleClick(idx));
          },
          key: idx
        }, renderProp(onChange, current === idx, text));
      })));
    }
  }]);

  return Chooser;
}(React__default.Component);

Chooser.propTypes = {
  data: PropTypes.arrayOf(PropTypes.func),
  onChange: PropTypes.func,
  text: PropTypes.string,
  title: PropTypes.string
};
Chooser.defaultProps = {
  data: [function () {}],
  onChange: function onChange() {},
  text: '',
  title: ''
};

var check$1 = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNyAxNyI+PGNpcmNsZSBjeD0iOC41IiBjeT0iOC41IiByPSI3LjUiIGZpbGw9IiNmZmYiIHN0cm9rZT0iIzAwNWZlYyIgc3Ryb2tlLXdpZHRoPSIyIi8+PHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDA1ZmVjIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIgZD0iTTUuNzEgOC40OWwxLjU0IDEuNyAzLjI2LTMuNjEiLz48L3N2Zz4=';

var Option =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Option, _React$Component);

  function Option() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Option);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Option)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var value = event.target.dataset.value;
      var onChange = _this.props.onChange;
      onChange(value);
    });

    return _this;
  }

  _createClass(Option, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          selected = _this$props.selected,
          value = _this$props.value,
          color = _this$props.color,
          border = _this$props.border;
      var className = 'OptionColor';
      return React__default.createElement("div", {
        className: cx(className, _defineProperty({
          border: border
        }, "".concat(className, "--selected"), selected)),
        "data-value": value,
        onClick: this.handleClick,
        onKeyDown: keyboardClick(this.handleClick),
        style: {
          background: color
        }
      }, selected && React__default.createElement(Svg, {
        className: "Check",
        src: check$1,
        width: "17px",
        height: "17px"
      }));
    }
  }]);

  return Option;
}(React__default.Component);

Option.propTypes = {
  onChange: PropTypes.func,
  selected: PropTypes.bool,
  value: PropTypes.string,
  color: PropTypes.string,
  border: PropTypes.bool
};
Option.defaultProps = {
  onChange: function onChange() {},
  selected: false,
  value: '',
  color: '',
  border: false
};

var OutsideDetector =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(OutsideDetector, _React$PureComponent);

  function OutsideDetector() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OutsideDetector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutsideDetector)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "setWrapperRef", function (node) {
      _this.wrapperRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (event) {
      var clickOutside = _this.props.clickOutside;

      if (_this.wrapperRef && !_this.wrapperRef.contains(event.target) && clickOutside) {
        clickOutside();
      }
    });

    return _this;
  }

  _createClass(OutsideDetector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClickOutside, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside, true);
    }
  }, {
    key: "render",
    value: function render() {
      return React__default.createElement("div", {
        ref: this.setWrapperRef
      }, this.props.children);
    }
  }]);

  return OutsideDetector;
}(React__default.PureComponent);
OutsideDetector.propTypes = {
  children: PropTypes.node.isRequired,
  clickOutside: PropTypes.func
};

var defaultColor = 'white';

var OptionColorPicker =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(OptionColorPicker, _React$PureComponent);

  function OptionColorPicker() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OptionColorPicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OptionColorPicker)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      pickedColor: '',
      isOpen: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeComplete", function (color) {
      _this.setState({
        pickedColor: color.hex
      });

      _this.setState({
        isOpen: false
      });

      _this.props.onChange(color.hex || color);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function () {
      _this.setState({
        isOpen: false
      });

      _this.props.onChange(_this.state.pickedColor || defaultColor);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOptionClick", function () {
      _this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      });

      _this.props.onChange(_this.state.pickedColor);
    });

    return _this;
  }

  _createClass(OptionColorPicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          selected = _this$props.selected,
          color = _this$props.color;
      var className = 'OptionColor';
      return React__default.createElement("div", {
        className: cx(className, _defineProperty({
          'border-gray': !this.state.pickedColor
        }, "".concat(className, "--selected"), selected)),
        onClick: this.handleOptionClick,
        onKeyDown: keyboardClick(this.handleOptionClick),
        style: {
          background: this.state.pickedColor || color
        }
      }, selected && React__default.createElement(Svg, {
        className: cx('Check'),
        src: check$1,
        width: "17px",
        height: "17px"
      }), this.state.isOpen && React__default.createElement(OutsideDetector, {
        clickOutside: this.handleClickOutside
      }, React__default.createElement("div", {
        className: "OptionColor--picker"
      }, React__default.createElement(CirclePicker, {
        color: this.state.pickedColor,
        onChangeComplete: this.handleChangeComplete
      }))));
    }
  }]);

  return OptionColorPicker;
}(React__default.PureComponent);

OptionColorPicker.propTypes = {
  onChange: PropTypes.func,
  selected: PropTypes.bool,
  color: PropTypes.string
};
OptionColorPicker.defaultProps = {
  onChange: function onChange() {},
  selected: false,
  color: ''
};

var OptionExpand =
/*#__PURE__*/
function (_React$Component) {
  _inherits(OptionExpand, _React$Component);

  function OptionExpand() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OptionExpand);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OptionExpand)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      var _this$props = _this.props,
          value = _this$props.value,
          onChange = _this$props.onChange;
      onChange(value);
    });

    return _this;
  }

  _createClass(OptionExpand, [{
    key: "render",
    value: function render() {
      var _cx, _cx2;

      var className = 'CircleExpand';
      var _this$props2 = this.props,
          icon = _this$props2.icon,
          text = _this$props2.text,
          selected = _this$props2.selected;
      return React__default.createElement("div", {
        className: cx((_cx = {}, _defineProperty(_cx, className, !text), _defineProperty(_cx, "".concat(className, "--expanded"), text), _defineProperty(_cx, "".concat(className, "--selected"), selected), _cx)),
        onClick: this.handleChange,
        onKeyDown: keyboardClick(this.handleChange)
      }, React__default.createElement("div", {
        className: cx((_cx2 = {}, _defineProperty(_cx2, "".concat(className, "--container"), !text), _defineProperty(_cx2, "".concat(className, "--expanded--container"), text), _cx2))
      }, React__default.createElement(Svg, {
        src: icon,
        width: "24px",
        height: "24px",
        color: "white"
      }), React__default.createElement("span", null, text)), selected && React__default.createElement(Svg, {
        className: cx('Check'),
        src: check$1,
        width: "17px",
        height: "17px"
      }));
    }
  }]);

  return OptionExpand;
}(React__default.Component);

OptionExpand.propTypes = {
  onChange: PropTypes.func,
  selected: PropTypes.bool,
  value: PropTypes.string,
  text: PropTypes.string,
  icon: PropTypes.string
};
OptionExpand.defaultProps = {
  onChange: function onChange() {},
  selected: false,
  value: '',
  text: '',
  icon: ''
};

var ConfirmationModal =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ConfirmationModal, _React$PureComponent);

  function ConfirmationModal() {
    _classCallCheck(this, ConfirmationModal);

    return _possibleConstructorReturn(this, _getPrototypeOf(ConfirmationModal).apply(this, arguments));
  }

  _createClass(ConfirmationModal, [{
    key: "render",
    value: function render() {
      return React__default.createElement("div", null, "ConfirmationModal");
    }
  }]);

  return ConfirmationModal;
}(React__default.PureComponent);

var ContactItem =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ContactItem, _React$PureComponent);

  function ContactItem(props) {
    var _this;

    _classCallCheck(this, ContactItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ContactItem).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "togglePopover", function (show) {
      var showTooltip = _this.props.showTooltip;
      if (showTooltip) _this.setState({
        show: show
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openPopover", function () {
      return _this.togglePopover(true);
    });

    _defineProperty(_assertThisInitialized(_this), "closePopover", function () {
      return _this.togglePopover(false);
    });

    _this.state = {
      show: false
    };
    return _this;
  }

  _createClass(ContactItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          status = _this$props.status,
          size = _this$props.size,
          className = _this$props.className,
          src = _this$props.src,
          color = _this$props.color,
          clickHandler = _this$props.clickHandler;
      var show = this.state.show;
      return React__default.createElement("div", {
        className: "ContactItem",
        onClick: clickHandler,
        onKeyDown: keyboardClick(clickHandler),
        role: "button",
        tabIndex: 0
      }, React__default.createElement(Popover, {
        isOpen: show,
        transitionDuration: -1,
        position: ['top', 'right', 'left', 'bottom'],
        onClickOutside: this.closePopover,
        content: function content(_ref) {
          var position = _ref.position,
              targetRect = _ref.targetRect,
              popoverRect = _ref.popoverRect;
          return React__default.createElement(ArrowContainer, {
            position: position,
            targetRect: targetRect,
            popoverRect: popoverRect,
            arrowColor: "white",
            arrowSize: 6
          }, React__default.createElement("span", {
            className: "ContactItem__tooltip-text"
          }, status));
        }
      }, React__default.createElement("div", {
        className: cx('ContactItem__avatar', className),
        onMouseOver: this.openPopover,
        onMouseOut: this.closePopover
      }, React__default.createElement(UserAvatar, {
        name: name,
        size: size,
        src: src,
        color: color
      }), React__default.createElement(UserStatusIcon, {
        status: status,
        size: size
      }))), React__default.createElement("div", {
        className: cx('ContactItem__text-container', "".concat(className, "__text-container"))
      }, React__default.createElement("span", {
        className: "ContactItem__text"
      }, name), React__default.createElement("span", {
        className: "ContactItem__status"
      }, status)));
    }
  }]);

  return ContactItem;
}(React__default.PureComponent);

ContactItem.propTypes = {
  name: PropTypes.string,
  status: PropTypes.oneOf(['online', 'offline', 'away', 'disturb']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
  src: PropTypes.string,
  color: PropTypes.shape({
    color: PropTypes.string,
    backgroundColor: PropTypes.string
  }),
  showTooltip: PropTypes.bool,
  clickHandler: PropTypes.func
};
ContactItem.defaultProps = {
  name: 'undefined',
  status: 'offline',
  color: {
    color: '#ffffff',
    backgroundColor: '#3d85d1'
  },
  size: 'medium',
  clickHandler: noop,
  showTooltip: true
};

var ContactList =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ContactList, _React$PureComponent);

  function ContactList() {
    _classCallCheck(this, ContactList);

    return _possibleConstructorReturn(this, _getPrototypeOf(ContactList).apply(this, arguments));
  }

  _createClass(ContactList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          clickHandler = _this$props.clickHandler;
      return React__default.createElement("ul", {
        className: "ContactList"
      }, data.map(function (i) {
        return React__default.createElement("li", {
          key: i.id,
          className: "ContactList--item"
        }, React__default.createElement("div", {
          className: "ContactList--container"
        }, React__default.createElement(ContactItem, {
          size: 25,
          statusSize: 10,
          name: i.name,
          status: i.status,
          className: "medium dark",
          clickHandler: clickHandler
        })));
      }));
    }
  }]);

  return ContactList;
}(React__default.PureComponent);

ContactList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    status: PropTypes.string
  })).isRequired,
  clickHandler: PropTypes.func
};

var SendContactForm =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(SendContactForm, _React$PureComponent);

  function SendContactForm(props) {
    var _this;

    _classCallCheck(this, SendContactForm);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SendContactForm).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "changeInput", function (event) {
      return _this.setState(_defineProperty({}, event.target.name, event.target.value));
    });

    _this.state = {
      name: '',
      mail: '',
      description: ''
    };
    return _this;
  }

  _createClass(SendContactForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var submitHandler = this.props.submitHandler;
      var _this$state = this.state,
          name = _this$state.name,
          mail = _this$state.mail,
          description = _this$state.description;
      return React__default.createElement("form", null, React__default.createElement("div", null, React__default.createElement(InputComponent, {
        name: "name",
        value: name,
        handler: this.changeInput,
        className: "customer-name rtc-input",
        placeholder: "Your Name",
        pattern: '[a-zA-Z0-9 ]{2,60}'
      }), React__default.createElement(InputComponent, {
        name: "mail",
        value: mail,
        handler: this.changeInput,
        className: "customer-name rtc-input",
        placeholder: "Your Name",
        pattern: '[a-zA-Z0-9 ]{2,60}'
      }), React__default.createElement(TextAreaComponent, {
        name: "description",
        value: description,
        handler: this.changeInput,
        className: "customer-question",
        placeholder: "How can we help you?"
      })), React__default.createElement(ButtonComponent, {
        className: "send-button",
        handler: function handler() {
          return submitHandler(_this2.state);
        },
        value: "submit"
      }));
    }
  }]);

  return SendContactForm;
}(React__default.PureComponent);

SendContactForm.propTypes = {
  submitHandler: PropTypes.func.isRequired
};

var Content =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Content, _React$PureComponent);

  function Content() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Content);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Content)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "submit", function (param) {
      return console.log(param);
    });

    return _this;
  }

  _createClass(Content, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          footer = _this$props.footer;
      return React__default.createElement("div", {
        className: footer ? 'container expand' : 'container'
      }, children, React__default.createElement(SendContactForm, {
        submitHandler: this.submit
      }));
    }
  }]);

  return Content;
}(React__default.PureComponent);

Content.propTypes = {
  children: PropTypes.node,
  footer: PropTypes.bool
};

var Container =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Container, _React$PureComponent);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, _getPrototypeOf(Container).apply(this, arguments));
  }

  _createClass(Container, [{
    key: "render",
    value: function render() {
      var on = React__default.createElement("div", {
        className: "email-message"
      }, "Fill out the form to help us better understand your inquiry.");
      var off = React__default.createElement("div", {
        className: "email-message"
      }, "Please send us an email and we will get back to you as soon as possible.");
      var online = this.props.online;
      var some = online ? on : off;
      return React__default.createElement(Content, this.props, some);
    }
  }]);

  return Container;
}(React__default.PureComponent);

Container.propTypes = {
  online: PropTypes.bool
};

var CustomerFooter = function CustomerFooter(_ref) {
  var title = _ref.title,
      src = _ref.src;
  return React__default.createElement("div", {
    className: "Footer"
  }, React__default.createElement("div", {
    className: "Footer-logo"
  }, src && React__default.createElement("img", {
    src: src,
    alt: "company logo"
  })), React__default.createElement("div", {
    className: "Footer-description"
  }, title));
};

CustomerFooter.propTypes = {
  title: PropTypes.string,
  src: PropTypes.string
};
CustomerFooter.defaultProps = {
  title: 'POWERED BY NEXTIVA CHAT',
  src: ''
};

var CustomerChatWindow =
/*#__PURE__*/
function (_ChatWindow) {
  _inherits(CustomerChatWindow, _ChatWindow);

  function CustomerChatWindow() {
    _classCallCheck(this, CustomerChatWindow);

    return _possibleConstructorReturn(this, _getPrototypeOf(CustomerChatWindow).apply(this, arguments));
  }

  _createClass(CustomerChatWindow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          online = _this$props.online,
          children = _this$props.children,
          header = _this$props.header,
          closeHandler = _this$props.closeHandler;
      return React__default.createElement("div", {
        className: "CustomerChat"
      }, React__default.createElement("div", {
        className: "CustomerChat-container"
      }, header && React__default.createElement(CustomerHeader, {
        online: online,
        header: header,
        closeHandler: closeHandler
      }), children, React__default.createElement(CustomerFooter, {
        title: "Powered by Nextiva Chat"
      })));
    }
  }]);

  return CustomerChatWindow;
}(ChatWindow);

CustomerChatWindow.propTypes = {
  closeHandler: PropTypes.func,
  online: PropTypes.bool,
  header: PropTypes.string,
  footerText: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
CustomerChatWindow.defaultProps = {
  closeHandler: function closeHandler() {},
  online: false,
  header: 'Chat with us!'
};

var toggleIcon = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3Ljg1MyIgaGVpZ2h0PSIxMS4yODgiIHZpZXdCb3g9IjAgMCA3Ljg1MyAxMS4yODgiPjxwYXRoIGQ9Ik0wIDIuMjU4bDMuMzY1IDMuMzg2TDAgOS4wM2wyLjI0NCAyLjI1OCA1LjYwOS01LjY0NEwyLjI0NCAweiIgZmlsbD0iIzIzMjY0OSIvPjwvc3ZnPg==';

var InteractionCard = function InteractionCard(_ref) {
  var className = _ref.className,
      name = _ref.name,
      phone = _ref.phone,
      avatar = _ref.avatar,
      date = _ref.date,
      timers = _ref.timers,
      note = _ref.note,
      sentiment = _ref.sentiment,
      surveyResponse = _ref.surveyResponse,
      chatHistory = _ref.chatHistory;
  var blockName = 'ch-interaction-card';

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isConversationOpen = _useState4[0],
      setIsConversationOpen = _useState4[1];

  var toggleDetails = function toggleDetails() {
    return setIsOpen(!isOpen);
  };

  var toggleChatConversation = function toggleChatConversation() {
    return setIsConversationOpen(!isConversationOpen);
  };

  var finalClassName = cx(blockName, className);
  var formattedDate = isOpen ? "".concat(format$1(date, 'MMMM d, y, h:mm a'), " (").concat(formatDistanceToNow(date), " ago)") : format$1(date, 'MMM d h:mm a');
  var userInfo = phone ? React__default.createElement(React__default.Fragment, null, React__default.createElement("span", {
    className: "".concat(blockName, "__name")
  }, name), React__default.createElement("span", {
    className: "".concat(blockName, "__phone")
  }, phone)) : React__default.createElement("span", {
    className: "".concat(blockName, "__name")
  }, name);

  var renderSurveyResponse = function renderSurveyResponse() {
    return React__default.createElement("div", {
      className: "".concat(blockName, "__survey-data")
    }, React__default.createElement(Rating, {
      readOnly: true,
      value: surveyResponse.value,
      maxValeu: surveyResponse.maxValue
    }), surveyResponse.date && React__default.createElement("span", {
      className: "".concat(blockName, "__survey-date")
    }, "(", format$1(surveyResponse.date, 'M-d-YYYYY'), ")"));
  };

  return React__default.createElement("div", {
    className: finalClassName
  }, React__default.createElement("div", {
    className: "".concat(blockName, "__header"),
    onClick: toggleDetails,
    onKeyDown: keyboardClick(toggleDetails)
  }, React__default.createElement(UserAvatar, {
    name: name,
    src: avatar
  }), React__default.createElement("div", {
    className: "".concat(blockName, "__user-details")
  }, React__default.createElement("div", {
    className: "".concat(blockName, "__user-name")
  }, name), React__default.createElement("div", {
    className: "".concat(blockName, "__interaction-date")
  }, formattedDate))), isOpen && React__default.createElement(React__default.Fragment, null, React__default.createElement("div", {
    className: "".concat(blockName, "__content")
  }, React__default.createElement("div", {
    className: "".concat(blockName, "__details")
  }, React__default.createElement("div", {
    className: "".concat(blockName, "__details-chat")
  }, React__default.createElement(ExtraInfo, {
    className: "".concat(blockName, "__details-user"),
    kind: "interaction",
    label: "wrote",
    value: userInfo,
    noMargin: true
  }), timers && React__default.createElement("div", {
    className: "".concat(blockName, "__details-timers")
  }, timers.map(function (t, i) {
    return React__default.createElement(ExtraInfo, {
      className: "".concat(blockName, "__timer"),
      label: t.label,
      value: t.value,
      kind: "interaction",
      noMargin: true,
      alignRight: true,
      key: i
    });
  }))), note && React__default.createElement(ExtraInfo, {
    className: "".concat(blockName, "__notes"),
    label: "Notes",
    value: note,
    kind: "interaction",
    noMargin: true
  }), (sentiment || surveyResponse) && React__default.createElement("div", {
    className: "".concat(blockName, "__sentiment-and-survey")
  }, sentiment && React__default.createElement(ExtraInfo, {
    label: "sentiment",
    value: sentiment
  }), surveyResponse && React__default.createElement(ExtraInfo, {
    className: "".concat(blockName, "__survey"),
    label: "survey response",
    value: renderSurveyResponse(),
    kind: "interaction",
    noMargin: true
  })))), isConversationOpen && React__default.createElement("div", {
    className: "".concat(blockName, "__conversation")
  }, React__default.createElement(ChatThread, {
    data: chatHistory
  })), React__default.createElement("div", {
    className: "".concat(blockName, "__controls"),
    onClick: toggleChatConversation,
    onKeyDown: keyboardClick(toggleChatConversation)
  }, React__default.createElement("div", {
    className: cx("".concat(blockName, "__toggle"), _defineProperty({}, "".concat(blockName, "__toggle--open"), isConversationOpen))
  }, React__default.createElement("span", {
    className: "".concat(blockName, "__toggle-text")
  }, "".concat(isConversationOpen ? 'Hide' : 'Show', " chat conversation")), React__default.createElement(Svg, {
    className: "".concat(blockName, "__toggle-icon"),
    src: toggleIcon,
    width: 8
  })))));
};

InteractionCard.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  phone: PropTypes.string,
  avatar: PropTypes.string,
  date: PropTypes.number,
  timers: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),
  note: PropTypes.string,
  sentiment: PropTypes.string,
  surveyResponse: PropTypes.shape({
    maxValue: PropTypes.number,
    value: PropTypes.number,
    date: PropTypes.string
  }),
  chatHistory: ChatThread.propTypes.data
};
InteractionCard.defaultProps = {
  className: '',
  name: '',
  phone: '',
  avatar: '',
  date: '',
  note: '',
  sentiment: '',
  surveyResponse: null,
  chatHistory: []
};

var InputCounter =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(InputCounter, _React$PureComponent);

  function InputCounter() {
    _classCallCheck(this, InputCounter);

    return _possibleConstructorReturn(this, _getPrototypeOf(InputCounter).apply(this, arguments));
  }

  _createClass(InputCounter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handler = _this$props.handler,
          max = _this$props.max,
          text = _this$props.text;
      return React__default.createElement(React__default.Fragment, null, React__default.createElement(InputComponent, {
        value: text,
        handler: handler,
        className: "input-counter"
      }), React__default.createElement("span", {
        className: "input-counter--character-count"
      }, "".concat(text.length, "/").concat(max)));
    }
  }]);

  return InputCounter;
}(React__default.PureComponent);

InputCounter.propTypes = {
  handler: PropTypes.func.isRequired,
  text: PropTypes.string,
  max: PropTypes.number
};
InputCounter.defaultProps = {
  text: '',
  max: 300
};

var BurgerMenu =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(BurgerMenu, _React$PureComponent);

  function BurgerMenu() {
    _classCallCheck(this, BurgerMenu);

    return _possibleConstructorReturn(this, _getPrototypeOf(BurgerMenu).apply(this, arguments));
  }

  _createClass(BurgerMenu, [{
    key: "render",
    value: function render() {
      return React__default.createElement("span", {
        className: "burger-menu"
      });
    }
  }]);

  return BurgerMenu;
}(React__default.PureComponent);

var ConfirmWindow =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ConfirmWindow, _React$PureComponent);

  function ConfirmWindow() {
    _classCallCheck(this, ConfirmWindow);

    return _possibleConstructorReturn(this, _getPrototypeOf(ConfirmWindow).apply(this, arguments));
  }

  _createClass(ConfirmWindow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          confirm = _this$props.confirm,
          decline = _this$props.decline;
      return React__default.createElement("div", {
        className: "status-form"
      }, React__default.createElement("div", {
        className: "confirm-exit"
      }, React__default.createElement("div", {
        className: "modal-text"
      }, React__default.createElement("span", null, "Are you sure want to exit?")), React__default.createElement("div", {
        className: "rtc-status-form__buttons"
      }, React__default.createElement(ButtonComponent, {
        className: "send-button modal-button orange",
        handler: confirm,
        value: "yes"
      }), React__default.createElement(ButtonComponent, {
        className: "send-button modal-button",
        handler: decline,
        value: "no"
      }))));
    }
  }]);

  return ConfirmWindow;
}(React__default.PureComponent);

ConfirmWindow.propTypes = {
  confirm: PropTypes.func.isRequired,
  decline: PropTypes.func.isRequired
};

var SearchBar =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(SearchBar, _React$PureComponent);

  function SearchBar() {
    _classCallCheck(this, SearchBar);

    return _possibleConstructorReturn(this, _getPrototypeOf(SearchBar).apply(this, arguments));
  }

  _createClass(SearchBar, [{
    key: "render",
    value: function render() {
      return React__default.createElement("div", {
        className: "SearchBar"
      }, React__default.createElement("div", {
        className: "SearchBar--wrapper"
      }, React__default.createElement("input", {
        className: "SearchBar--input",
        type: "text",
        name: "",
        value: ""
      })));
    }
  }]);

  return SearchBar;
}(React__default.PureComponent);

SearchBar.propTypes = {};
SearchBar.defaultProps = {};

var SelectInput =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(SelectInput, _React$PureComponent);

  function SelectInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SelectInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SelectInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      values: [],
      focusedValue: -1,
      isOpen: _this.props.isOpen || false
    });

    _defineProperty(_assertThisInitialized(_this), "togglePopover", function () {
      _this.setState(function (state) {
        return {
          isOpen: !state.isOpen
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteOption", function (e) {
      var value = e.currentTarget.dataset.value;

      _this.setState(function (state) {
        var _state$values = _toArray(state.values),
            values = _state$values.slice(0);

        var index = values.indexOf(value);
        values.splice(index, 1);
        return {
          values: values
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOptionClick", function (e) {
      var _this$props = _this.props,
          multiple = _this$props.multiple,
          onChange = _this$props.onChange;
      var value = e.currentTarget.dataset.value;

      _this.setState(function (state) {
        if (!multiple) {
          onChange(value);
          return {
            values: [value],
            isOpen: false
          };
        }

        var _state$values2 = _toArray(state.values),
            values = _state$values2.slice(0);

        var index = values.indexOf(value);

        if (index === -1) {
          values.push(value);
        } else {
          values.splice(index, 1);
        }

        return {
          values: values
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderValues", function () {
      var values = _this.state.values;
      return React__default.createElement("div", {
        className: "select-input__value"
      }, values[0]);
    });

    _defineProperty(_assertThisInitialized(_this), "renderOptions", function () {
      var options = _this.props.options;
      var isOpen = _this.state.isOpen;

      if (!isOpen) {
        return null;
      }

      return React__default.createElement("div", {
        className: "select-input__options"
      }, options.map(_this.renderOption));
    });

    _defineProperty(_assertThisInitialized(_this), "renderOption", function (option) {
      var values = _this.state.values;
      var value = option.value,
          color = option.color;
      var selected = values.includes(value);
      var optionClassName = 'select-input__option';
      var finalClassName = cx(optionClassName, color);
      return React__default.createElement("div", {
        key: value,
        "data-value": value,
        className: finalClassName,
        onMouseOver: _this.handleOptionHover,
        onClick: _this.handleOptionClick,
        onKeyDown: keyboardClick(_this.handleOptionClick),
        role: "option",
        tabIndex: 0,
        "aria-selected": selected
      }, value);
    });

    return _this;
  }

  _createClass(SelectInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          onChange = _this$props2.onChange,
          options = _this$props2.options;
      var val = options[0].value;
      this.setState({
        values: [val]
      });
      onChange(options[0].value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          values = _this$state.values;
      var options = this.props.options;
      var currentSelection = find(options, function (o) {
        return o.value === values[0];
      });
      return React__default.createElement("div", {
        className: "select-input"
      }, React__default.createElement("div", {
        className: "select-input__selection ".concat(currentSelection && currentSelection.color),
        onClick: this.togglePopover,
        onKeyDown: keyboardClick(this.togglePopover)
      }, this.renderValues(), React__default.createElement("span", {
        className: "select-input__arrow"
      }, React__default.createElement("div", {
        className: "select-input--triangle-".concat(isOpen ? 'up' : 'down')
      }))), this.renderOptions());
    }
  }]);

  return SelectInput;
}(React__default.PureComponent);

SelectInput.propTypes = {
  options: PropTypes.shape({
    value: PropTypes.string,
    color: PropTypes.string
  }),
  onChange: PropTypes.func,
  multiple: PropTypes.bool,
  isOpen: PropTypes.bool
};

var Spinner = function Spinner(_ref) {
  var color = _ref.color,
      trackColor = _ref.trackColor,
      thickness = _ref.thickness,
      size = _ref.size,
      blockName = _ref.blockName,
      className = _ref.className,
      style = _ref.style,
      other = _objectWithoutProperties(_ref, ["color", "trackColor", "thickness", "size", "blockName", "className", "style"]);

  var finalClassName = cx(blockName, className);
  var finalSpinnerClassName = cx("".concat(blockName, "__spinner"), _defineProperty({}, "".concat(className, "__spinner"), className));
  var blockSize = {
    width: size,
    height: size
  };
  return React__default.createElement("div", _extends({
    className: finalClassName,
    style: _objectSpread2({}, blockSize, {}, style)
  }, other), React__default.createElement("svg", {
    className: finalSpinnerClassName,
    style: blockSize
  }, React__default.createElement("g", null, React__default.createElement("rect", {
    fill: "transparent",
    stroke: trackColor,
    strokeWidth: thickness,
    width: size - thickness,
    height: size - thickness,
    x: thickness / 2,
    y: thickness / 2,
    rx: size,
    ry: size
  }), React__default.createElement("circle", {
    fill: "transparent",
    stroke: color,
    strokeWidth: thickness,
    strokeLinecap: "round",
    cx: "".concat(size / 2),
    cy: "".concat(size / 2),
    r: "".concat(size / 2 - thickness / 2),
    strokeDasharray: "100",
    pathLength: "100"
  }))));
};

Spinner.propTypes = {
  blockName: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.number,
  thickness: PropTypes.number,
  color: PropTypes.string,
  trackColor: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.string)
};
Spinner.defaultProps = {
  blockName: 'ch-spinner',
  thickness: 3.5,
  size: 40,
  color: '#3d84d1',
  trackColor: '#d6e5f5'
};

var options = [{
  value: 'Online',
  color: 'green'
}, {
  value: 'Away',
  color: 'yellow'
}, {
  value: 'Do Not Disturb',
  color: 'red'
}, {
  value: 'Offline',
  color: 'gray'
}];

var StatusSelect =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(StatusSelect, _React$PureComponent);

  function StatusSelect(props, context) {
    var _this;

    _classCallCheck(this, StatusSelect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StatusSelect).call(this, props, context));
    _this.state = {
      text: '',
      max: 10,
      status: ''
    };
    return _this;
  }

  _createClass(StatusSelect, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          confirm = _this$props.confirm,
          decline = _this$props.decline;
      var _this$state = this.state,
          max = _this$state.max,
          text = _this$state.text,
          status = _this$state.status;
      return React__default.createElement("div", {
        className: "status-form--agent"
      }, React__default.createElement("div", {
        className: "status-form--container"
      }, React__default.createElement("div", {
        className: "status-form--input"
      }, React__default.createElement(SelectInput, {
        options: options,
        onChange: function onChange(s) {
          return _this2.setState({
            status: s
          });
        },
        value: status
      })), React__default.createElement("div", {
        className: "status-form--input"
      }, React__default.createElement(InputCounter, {
        max: max,
        text: text,
        handler: function handler(e) {
          return e.target.value.length < max && _this2.setState({
            text: e.target.value
          });
        }
      })), React__default.createElement("div", {
        className: "status-form--controls"
      }, React__default.createElement(ButtonComponent, {
        className: "status-form--button gray",
        handler: decline,
        value: "Cancel"
      }), React__default.createElement(ButtonComponent, {
        className: "status-form--button green",
        handler: confirm(status),
        value: "Save"
      }))));
    }
  }]);

  return StatusSelect;
}(React__default.PureComponent);

StatusSelect.propTypes = {
  confirm: PropTypes.func.isRequired,
  decline: PropTypes.func.isRequired
};

export { AgentChatInput, AgentChatInvitation, AgentChatTransfer, AgentChatWidget, AgentEndChat, Avatar, BusinessHoursPicker, Button$1 as Button, ButtonComponent, ButtonsContainer, Card, ChatButton, ChatEndConfirmation, ChatIcon, ChatPop, ChatPopControls, ChatPopMessages, ChatThread, ChatThreadUserStatus, ChatWindow, Checkable, Checkbox, Chip, Chooser, CloseButton, CloseIcon, CollapseIcon, ConfirmationModal as ConfimationModal, ContactItem, ContactList, Container, Content, Countdown, CustomerChatInput, CustomerChatWindow, CustomerFooter, CustomerForm, CustomerHeader, DotLoader, ExtraInfo, InputComponent, InputCounter, InteractionCard, MailIcon, BurgerMenu as Menu, MinifyButton, ConfirmWindow as ModalConfirm, NextivaLogo, Option, OptionColorPicker, OptionExpand, OutsideDetector, RangeField, Rating, ScrollContainer, SearchBar, SearchField$1 as SearchField, SelectInput, SendContactForm, Spinner, StatusSelect as StatusSelectModal, Svg, SvgButton, TextArea$1 as TextArea, TextAreaComponent, TextField$1 as TextField, TimeTextField, ToggleArea, UserAvatar, UserStatusIcon, WelcomeButton, WithNewLines, addPx, keyboardClick, withEditableField, withFocusedState, parseXml as xml };
